console.log(
"=== ⚠️ LEGAL NOTICE (DMCA PROTECTED CODE) ⚠️ ===\n\n" +
  "%ccopyright © 2025 NEXTGEN IT SOLUTIONS\n\n" +
  "This JavaScript source (and associated HTML/CSS) is registered and protected under applicable copyright laws, including the DMCA.%c\n\n" +
  "Any use of this code — including copy-pasting, modifying, adapting, or reusing it in whole or in part — without explicit permission will be treated as a violation and subject to an international DMCA takedown notice.\n\n" +
  "%cWhen I discover my code has been reused on your website (not if, when), I will file a DMCA takedown request with your domain host and hosting provider.%c\n\n" +
  "Following that, I will pursue further actions intended to remove or reduce your site's visibility in search results.\n\n" +
  "Think carefully before using or republishing this code. Consider this your one and only warning.\n\n" +
  "=== ⚠️ LEGAL NOTICE (DMCA PROTECTED CODE) ⚠️ ===",
  "color: red; font-weight: bold; font-size: 16px;",  // Header style
  "color: black; font-weight: normal; font-size: 13px;", // Normal text
  "color: red; font-weight: bold; font-size: 14px;",  // SP Road warning section
  "color: black; font-weight: normal; font-size: 13px;"  // Closing text
);

// ==================== DEVICE DETECTION ====================
function isMobileDevice() {
  return window.innerWidth <= 768;
}

// ==================== GOOGLE SHEETS API CONFIGURATION ====================
const API_KEY = 'AIzaSyABPr1PtQkIap4R9cZooPrqIq-0t4xrEJk';
const SHEET_ID = '1ENTQvIUTBD3GO1DwDms47Gt6iZn1CgLHlGC4B427CsI';
const API_BASE_URL = `https://sheets.googleapis.com/v4/spreadsheets/${SHEET_ID}/values/`;
const IP_CHECKER_URL = 'https://ipinfo.io/json?token=71204a150e9874';

// Flag set after IP check
let csCalcIsIndiaUser = true;

// Category to Sheet Name Mapping
const CATEGORY_MAPPING = {
    'CPU': 'CPU', 
    'Motherboard': 'Motherboard',
    'RAM': 'RAM',
    'Storage (SSD)': 'Storage_SSD',
    'Storage (HDD)': 'Storage_HDD',
    'GPU': 'GPU', 
    'Cooling': 'Cooling',
    'PSU': 'PSU',
    'Case': 'Case',
    'Case Fan': 'Case_Fan',
    'Monitor': 'Monitor',
    'Keyboard': 'Keyboard',
    'Mouse': 'Mouse',
    'Headset': 'Headset',
    'Accessories': 'Accessories'
};

// ==================== BRAND LOGOS CONFIGURATION ====================
const BRAND_LOGOS = {
    // CPU Brands
    'AMD': { url: 'https://pcbuildz.in/cdn/shop/files/AMD-Brand-Logo.svg?v=1763714907', height: '14px' },
    'Intel': { url: 'https://pcbuildz.in/cdn/shop/files/intel-Brand-Logo.svg?v=1763714907', height: '16px' },
    
    // GPU Brands
    'NVIDIA': { url: 'https://pcbuildz.in/cdn/shop/files/Nvidia-Brand-Logo.svg?v=1763989344', height: '16px' },
    'ASUS': { url: 'https://pcbuildz.in/cdn/shop/files/ASUS-Brand-Logo.svg?v=1763714907', height: '12px' },
    'MSI': { url: 'https://pcbuildz.in/cdn/shop/files/MSI-Brand-Logo.svg?v=1763714906', height: '11px' },
    'Gigabyte': { url: 'https://pcbuildz.in/cdn/shop/files/Gigabyte-Brand-Logo.svg?v=1763989344', height: '11px' },
    'Zotac': { url: 'https://pcbuildz.in/cdn/shop/files/Zotac-Brand-Logo.svg?v=1763989343', height: '12px' },
    'Colorful': { url: 'https://pcbuildz.in/cdn/shop/files/Colorful-Brand-Logo.svg?v=1763714906', height: '10px' },
    'INNO3D': { url: 'https://pcbuildz.in/cdn/shop/files/INNO3D-Brand-Logo.svg?v=1763989344', height: '12px' },
    'PNY': { url: 'https://pcbuildz.in/cdn/shop/files/PNY-Brand-Logo.svg?v=1763989344', height: '12px' },
    'Galax': { url: 'https://pcbuildz.in/cdn/shop/files/Galax-Brand-Logo.svg?v=1763989343', height: '10px' },
    
    // Motherboard Brands
    'ASRock': { url: 'https://upload.wikimedia.org/wikipedia/commons/thumb/6/6c/ASRock_Logo_%282016%29.svg/320px-ASRock_Logo_%282016%29.svg.png', height: '20px' },
    
    // RAM Brands
    'Corsair': { url: 'https://pcbuildz.in/cdn/shop/files/Corsair-Brand-Logo.svg?v=1763714907', height: '20px' },
    'G.Skill': { url: 'https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/G.Skill_logo.svg/320px-G.Skill_logo.svg.png', height: '20px' },
    'Teamgroup': { url: 'https://pcbuildz.in/cdn/shop/files/TEAMGROUP-Brand-Logo.svg?v=1763716841', height: '14px' },
    'Crucial': { url: 'https://pcbuildz.in/cdn/shop/files/Crucial-Brand-Logo.svg?v=1763714906', height: '20px' },
    
    // Storage Brands
    'Samsung': { url: 'https://pcbuildz.in/cdn/shop/files/Samsung-Brand-Logo.svg?v=1763716607', height: '12px' },
    'Western Digital': { url: 'https://pcbuildz.in/cdn/shop/files/Western-Digital-Brand-Logo.svg?v=1763989344', height: '20px' },
    'Seagate': { url: 'https://pcbuildz.in/cdn/shop/files/Seagate-Brand-Logo.svg?v=1763717118', height: '22px' },
    'Kingston': { url: 'https://pcbuildz.in/cdn/shop/files/Kingston-Brand-Logo.svg?v=1763989344', height: '16px' },
    'XPG': { url: 'https://pcbuildz.in/cdn/shop/files/XPG-Brand-Logo.svg?v=1763989344', height: '16px' },
    'EVM': { url: 'https://pcbuildz.in/cdn/shop/files/EVM-Brand-Logo.svg?v=1763989344', height: '21px' },
    'WD': { url: 'https://pcbuildz.in/cdn/shop/files/Western-Digital-Brand-Logo.svg?v=1763991159', height: '12px' },
    
    // Case Brands
    'NZXT': { url: 'https://pcbuildz.in/cdn/shop/files/NZXT-Brand-Logo.svg?v=1763714906', height: '14px' },
    'Lian Li': { url: 'https://pcbuildz.in/cdn/shop/files/Lian-Li-Brand-Logo.svg?v=1763714907', height: '18px' },
    'Phanteks': { url: 'https://upload.wikimedia.org/wikipedia/commons/thumb/4/4a/Phanteks_Logo.svg/320px-Phanteks_Logo.svg.png', height: '20px' },
    'Fractal Design': { url: 'https://upload.wikimedia.org/wikipedia/commons/thumb/7/7a/Fractal_Design_logo.svg/320px-Fractal_Design_logo.svg.png', height: '20px' },
    
    // Cooling Brands
    'Noctua': { url: 'https://pcbuildz.in/cdn/shop/files/Noctua-Brand-Logo.svg?v=1763725301', height: '20px' },
    'Deepcool': { url: 'https://pcbuildz.in/cdn/shop/files/Deepcool-Brand-Logo.svg?v=1763989344', height: '20px' },
    'Ant Esports': { url: 'https://pcbuildz.in/cdn/shop/files/ANT-Esports-Brand-Logo.svg?v=1765963721', height: '28px' },
    
    // Monitor Brands
    'LG': { url: 'https://upload.wikimedia.org/wikipedia/commons/thumb/2/20/LG_symbol_2011.svg/320px-LG_symbol_2011.svg.png', height: '20px' },
    'Acer': { url: 'https://upload.wikimedia.org/wikipedia/commons/thumb/5/5d/Acer_2011_logo.svg/320px-Acer_2011_logo.svg.png', height: '20px' },
    'BenQ': { url: 'https://upload.wikimedia.org/wikipedia/commons/thumb/7/7c/BenQ_logo_2015.svg/320px-BenQ_logo_2015.svg.png', height: '20px' },
    
    // Peripheral Brands
    'Logitech': { url: 'https://pcbuildz.in/cdn/shop/files/Logitech-Brand-Logo.svg?v=1763715020', height: '20px' },
    'AOC': { url: 'https://pcbuildz.in/cdn/shop/files/AOC-Brand-Logo.svg?v=1766042706', height: '14px' },
    'CyberPower': { url: 'https://pcbuildz.in/cdn/shop/files/CyberPower-Brand-Logo.svg?v=1766042855', height: '16px' },
    'Cosmic Byte': { url: 'https://pcbuildz.in/cdn/shop/files/Cosmic-Byte-Brand-Logo-SVG.svg?v=1766043500', height: '22px' }
    
    // Add more brands as needed...
};

// ==================== DROPDOWN FILTERS CONFIGURATION ====================
const CATEGORY_FILTERS = {
    'CPU': [
        { label: 'All CPUs', value: '' },
        { label: 'AMD', value: 'AMD' },
        { label: 'Intel', value: 'Intel' }
    ],
    'GPU': [
        { label: 'All GPUs', value: '' },
        { label: 'RTX 5050', value: 'RTX 5050' },
        { label: 'RTX 5060', value: 'RTX 5060' },
        { label: 'RTX 5060 Ti', value: 'RTX 5060 Ti' },
        { label: 'RTX 5070', value: 'RTX 5070' },
        { label: 'RTX 5070 Ti', value: 'RTX 5070 Ti' },
        { label: 'RTX 5080', value: 'RTX 5080' },
        { label: 'RTX 5090', value: 'RTX 5090' }
    ],
    'Motherboard': [
        { label: 'All Motherboards', value: '' },
        // Intel Chipsets
        { label: 'Intel H610', value: 'H610' },
        { label: 'Intel B760', value: 'B760' },
        { label: 'Intel Z790', value: 'Z790' },
        { label: 'Intel B860', value: 'B860' },
        { label: 'Intel Z890', value: 'Z890' },
        // AMD Chipsets
        { label: 'AMD B650', value: 'B650' },
        { label: 'AMD B850', value: 'B850' },
        { label: 'AMD X870', value: 'X870' }
    ],
    'RAM': [
        { label: 'All RAM', value: '' },
        { label: '16GB', value: '16GB' },
        { label: '32GB', value: '32GB' },
        { label: '64GB', value: '64GB' }
    ],
    'Storage (SSD)': [
        { label: 'All SSDs', value: '' },
        { label: '512GB', value: '512GB' },
        { label: '1TB', value: '1TB' },
        { label: '2TB', value: '2TB' }
    ],
    'Storage (HDD)': [
        { label: 'All HDDs', value: '' },
        { label: '1TB', value: '1TB' },
        { label: '2TB', value: '2TB' },
        { label: '4TB', value: '4TB' }
    ],
    'PSU': [
        { label: 'All PSUs', value: '' },
        { label: '550W', value: '550' },
        { label: '650W', value: '650' },
        { label: '750W', value: '750' },
        { label: '850W', value: '850' },
        { label: '1000W', value: '1000' },
        { label: '1200W', value: '1200' },
        { label: '1500W+', value: '1500' }
    ],
    'Cooling': [
        { label: 'All Cooling', value: '' },
        { label: 'Air Cooler', value: 'Air' },
        { label: 'Liquid Cooler', value: 'Liquid' }
    ],
    'Case': [
        { label: 'All Cases', value: '' },
        { label: 'NZXT', value: 'NZXT' },
        { label: 'MSI', value: 'MSI' },
        { label: 'Deepcool', value: 'Deepcool' },
        { label: 'Fractal Design', value: 'Fractal Design' }
    ],
    'Monitor': [
        { label: 'All Monitors', value: '' },
        { label: '22-inch', value: '22' },
        { label: '24-inch', value: '24' },
        { label: '27-inch', value: '27' },
        { label: '32-inch', value: '32' },
        { label: '34-inch+', value: '34' }
    ],
    'Keyboard': [
        { label: 'All Keyboards', value: '' },
        { label: 'Wired', value: 'Wired' },
        { label: 'Wireless', value: 'Wireless' }
    ],
    'Mouse': [
        { label: 'All Mice', value: '' },
        { label: 'Wired', value: 'Wired' },
        { label: 'Wireless', value: 'Wireless' }
    ],
    'Headset': [
        { label: 'All Headsets', value: '' },
        { label: 'Wired', value: 'Wired' },
        { label: 'Wireless', value: 'Wireless' }
    ],
    'Case Fan': [],
    'Accessories': [
        { label: 'All Accessories', value: '' },
        { label: 'UPS', value: 'UPS' },
        { label: 'Mouse Pad', value: 'Mouse Pad' },
        { label: 'Gaming Chair', value: 'Gaming Chair' },
        { label: 'Cable', value: 'Cable' }
    ]
};

// Track selected filters
let selectedFilters = {
    'CPU': '',
    'GPU': '',
    'Motherboard': '',
    'RAM': '',
    'Storage (SSD)': '',
    'Storage (HDD)': '',
    'PSU': '',
    'Cooling': '',
    'Case': '',
    'Monitor': '',
    'Keyboard': '',
    'Mouse': '',
    'Headset': ''
};

// Track current active category
let currentActiveCategory = 'CPU';

// Track selected products globally
let selectedProducts = {
    'CPU': null,
    'GPU': null,
    'Motherboard': null,
    'RAM': null,
    'Storage (SSD)': null,
    'Storage (HDD)': null,
    'PSU': null,
    'Case': null,
    'Cooling': null,
    'Case Fan': null,
    'Monitor': null,
    'Keyboard': null,
    'Mouse': null,
    'Headset': null,
    'Accessories': null
};

// Track quantities for multi-quantity components
let productQuantities = {
    'RAM': 1,
    'Storage (SSD)': 1,
    'Storage (HDD)': 1,
    'Case Fan': 1,
    'Monitor': 1
};

// Track current visualizer category
let currentVisualizerCategory = 'Case';

// ==================== PAGINATION VARIABLES ====================
let currentPage = 1;
let productsPerPage = 9;
let currentProducts = [];

// ==================== GLOBAL PRODUCT CACHE ====================
window.csCalcAllProducts = {};   // { CPU: [products], GPU: [products], ... }
window.csCalcDataLoaded = false; // flag to avoid re-fetching

// ==================== aPDF.io CONFIGURATION ====================
//const APDF_API_URL = 'https://apdf.io/api/pdf/file/create';
// Mobile and Desktop use different tokens
//const APDF_MOBILE_TOKEN = 'zPSuNC00CsUKfVhWoOnZhha2bMAxacMMTH11ud3W7146b3e1';
//const APDF_DESKTOP_TOKEN = 'CTO9dOu6Qgey8mAiSDd807VpqYhIEXuokDsl6LVyf0cf1958';

// ==================== COMPATIBILITY BUTTON FUNCTIONS ====================
function scrollToCompatibilityWarnings() {
    const warningsSection = document.getElementById('compatibility-warnings');
    if (warningsSection) {
        const elementRect = warningsSection.getBoundingClientRect();
        const absoluteElementTop = elementRect.top + window.pageYOffset;
        const middle = absoluteElementTop - (window.innerHeight / 2) + (elementRect.height / 2);
        
        window.scrollTo({
            top: middle,
            behavior: 'smooth'
        });
        
        // Add a slight highlight effect
        warningsSection.style.transition = 'box-shadow 0.3s ease';
        warningsSection.style.boxShadow = '0 0 0 3px rgba(239, 68, 68, 0.3)';
        
        setTimeout(() => {
            warningsSection.style.boxShadow = '';
        }, 1000);
    }
}

function updateCompatibilityButtonVisibility(hasWarnings) {
    const desktopBtn = document.getElementById('compatibility-btn-desktop');
    const mobileBtn = document.getElementById('compatibility-btn-mobile');
    
    if (hasWarnings) {
        desktopBtn.classList.add('show');
        mobileBtn.classList.add('show');
    } else {
        desktopBtn.classList.remove('show');
        mobileBtn.classList.remove('show');
    }
}

// ==================== EMAIL FUNCTIONALITY ====================
const GOOGLE_SCRIPT_URL = 'https://script.google.com/macros/s/AKfycby9-aMYFJD6EvchJm6asYwtyM48wEknOevMGkLL2cvqLwOS7-8PGkXrrH6eeXicHhHL/exec';

// Rate limiting variables
let lastSubmissionTime = 0;

// ==================== UTILITY FUNCTIONS ====================
function pluralize(count, singular, plural) {
    return count === 1 ? singular : plural;
}

// ==================== GOOGLE DRIVE IMAGE URL CONVERSION ====================
function convertGoogleDriveUrl(url) {
    if (!url) return '';
    
    // Already a direct image URL
    if (url.includes('.jpg') || url.includes('.png') || url.includes('.webp') || url.includes('.jpeg')) {
        return url;
    }
    
    // Convert to lh3.googleusercontent.com
    if (url.includes('drive.google.com/file/d/')) {
        const match = url.match(/\/d\/([^\/]+)/);
        if (match && match[1]) {
            return `https://lh3.googleusercontent.com/d/${match[1]}`;
        }
    } else if (url.includes('drive.google.com/open?id=')) {
        const match = url.split('id=')[1];
        if (match) {
            return `https://lh3.googleusercontent.com/d/${match}`;
        }
    } else if (url.includes('/d/')) {
        const match = url.match(/\/d\/([^\/]+)/);
        if (match && match[1]) {
            return `https://lh3.googleusercontent.com/d/${match[1]}`;
        }
    }
    
    return url;
}

// ==================== INITIALIZATION ====================
document.addEventListener('DOMContentLoaded', function() {
    initializeCategoryTabs();
    initializeDropdowns();
    initializeVisualizerIcons();

    // Load CPU immediately for fast UI
loadCategoryProducts('CPU').then(() => {
    checkUserCountry();
}).catch(() => {
    checkUserCountry();
});

// Fetch all products in background (no UI dependency)
setTimeout(() => {
    fetchAllProductsOnce();
}, 50);

    updateCompatibilityButtonVisibility(false);
    updateCompatibilityStatus();
});

// ==================== MOBILE DROPDOWN ARROW ROTATION ====================
function updateMobileDropdownArrows() {
    const pills = document.querySelectorAll('.cs-calc-pill.has-dropdown');
    
    pills.forEach(pill => {
        const dropdown = pill.querySelector('.cs-calc-dropdown');
        const arrow = pill.querySelector('.cs-calc-pill-arrow');
        
        if (dropdown && arrow) {
            if (dropdown.classList.contains('active')) {
                arrow.style.transform = 'rotate(180deg)';
            } else {
                arrow.style.transform = 'rotate(0deg)';
            }
        }
    });
}

// ==================== UPDATED DROPDOWN INITIALIZATION ====================
function initializeDropdowns() {
    const pills = document.querySelectorAll('.cs-calc-pill');
    
    pills.forEach(pill => {
        const category = pill.dataset.category;
        const filters = CATEGORY_FILTERS[category];
        
        if (filters && filters.length > 0) {
            // Add has-dropdown class for styling
            pill.classList.add('has-dropdown');
            
            // Create dropdown container
            const dropdown = document.createElement('div');
            dropdown.className = 'cs-calc-dropdown';
            dropdown.id = `dropdown-${category}`;
            
            // Add filter items
            filters.forEach(filter => {
                const item = document.createElement('button');
                item.className = 'cs-calc-dropdown-item';
                item.textContent = filter.label;
                item.dataset.value = filter.value;
                item.dataset.category = category;
                
                item.addEventListener('click', function(e) {
                    e.stopPropagation();
                    handleFilterSelect(category, filter.value, filter.label);
                    hideAllDropdowns();
                    // Remove active-dropdown class after selection
                    pill.classList.remove('active-dropdown');
                    // Update arrow rotation
                    updateMobileDropdownArrows();
                });
                
                dropdown.appendChild(item);
            });
            
            pill.appendChild(dropdown);
            
            // Desktop behavior - click only opens dropdown, doesn't change category
            if (window.innerWidth > 768) {
                let hideTimeout;
                
                // Click event - only open dropdown
                pill.addEventListener('click', function(e) {
                    e.stopPropagation();
                    const isActive = dropdown.classList.contains('active');
                    hideAllDropdowns();
                    if (!isActive) {
                        dropdown.classList.add('active');
                        pill.classList.add('active-dropdown');
                    }
                    updateMobileDropdownArrows();
                });
                
                // Hover functionality remains
                pill.addEventListener('mouseenter', function() {
                    clearTimeout(hideTimeout);
                    hideAllDropdowns();
                    dropdown.classList.add('active');
                    pill.classList.add('active-dropdown');
                    updateMobileDropdownArrows();
                });
                
                pill.addEventListener('mouseleave', function(e) {
                    hideTimeout = setTimeout(() => {
                        if (!dropdown.matches(':hover')) {
                            dropdown.classList.remove('active');
                            pill.classList.remove('active-dropdown');
                            updateMobileDropdownArrows();
                        }
                    }, 150);
                });
                
                dropdown.addEventListener('mouseenter', function() {
                    clearTimeout(hideTimeout);
                    dropdown.classList.add('active');
                    pill.classList.add('active-dropdown');
                    updateMobileDropdownArrows();
                });
                
                dropdown.addEventListener('mouseleave', function() {
                    hideTimeout = setTimeout(() => {
                        dropdown.classList.remove('active');
                        pill.classList.remove('active-dropdown');
                        updateMobileDropdownArrows();
                    }, 150);
                });
            } else {
                // Mobile touch events - click only opens dropdown
                pill.addEventListener('click', function(e) {
                    e.stopPropagation();
                    const isActive = dropdown.classList.contains('active');
                    hideAllDropdowns();
                    if (!isActive) {
                        dropdown.classList.add('active');
                        pill.classList.add('active-dropdown');
                    }
                    updateMobileDropdownArrows();
                });
            }
        } else {
            // For pills without dropdowns, keep the original category change behavior
            pill.addEventListener('click', function(e) {
                if (window.innerWidth <= 768 && e.target.classList.contains('cs-calc-pill-arrow')) {
                    return;
                }
                
                const category = this.dataset.category;
                currentActiveCategory = category;
                activateCategoryTab(category);
                updateSelectedFilterDisplay(category);
                loadCategoryProducts(category);
            });
        }
    });
    
    // Close dropdowns when clicking outside
    document.addEventListener('click', function() {
        hideAllDropdowns();
        updateMobileDropdownArrows();
    });
}

// ==================== UPDATED HIDE ALL DROPDOWNS ====================
function hideAllDropdowns() {
    document.querySelectorAll('.cs-calc-dropdown').forEach(dropdown => {
        dropdown.classList.remove('active');
    });
    document.querySelectorAll('.cs-calc-pill').forEach(pill => {
        pill.classList.remove('active-dropdown');
    });
    // Update arrow rotation when hiding all dropdowns
    updateMobileDropdownArrows();
}

function handleFilterSelect(category, value, label) {
    selectedFilters[category] = value;
    
    // Update dropdown item states
    const dropdown = document.getElementById(`dropdown-${category}`);
    if (dropdown) {
        dropdown.querySelectorAll('.cs-calc-dropdown-item').forEach(item => {
            item.classList.remove('active');
            if (item.dataset.value === value) {
                item.classList.add('active');
            }
        });
    }
    
    // ACTIVATE THE CORRESPONDING MAIN CATEGORY TAB
    activateCategoryTab(category);
    
    // Update selected filter display
    updateSelectedFilterDisplay(category);
    
    // Reload products with filter
    loadCategoryProducts(category);
}

// ==================== NEW FUNCTION TO ACTIVATE CATEGORY TAB ====================
function activateCategoryTab(category) {
    const pills = document.querySelectorAll('.cs-calc-pill');
    
    pills.forEach(pill => {
        if (pill.dataset.category === category) {
            pill.classList.add('cs-calc-active');
            currentActiveCategory = category;
        } else {
            pill.classList.remove('cs-calc-active');
        }
    });
}

function updateSelectedFilterDisplay(category) {
    const selectedFilter = document.getElementById('selected-filter');
    const filterValue = document.getElementById('filter-value');
    
    // Only show if this is the current active category and there's a filter selected
    if (category === currentActiveCategory && selectedFilters[category]) {
        const filterLabel = CATEGORY_FILTERS[category]?.find(f => f.value === selectedFilters[category])?.label || selectedFilters[category];
        selectedFilter.classList.add('active');
        // CHANGED: Using right arrow instead of colon
        filterValue.innerHTML = `${category} &rarr; ${filterLabel}`;
    } else {
        selectedFilter.classList.remove('active');
    }
}

// ==================== BRAND LOGO FUNCTIONS ====================
function getBrandLogo(brandName) {
    if (!brandName) return '';
    
    const brand = BRAND_LOGOS[brandName];
    if (brand) {
        return `
            <span class="cs-calc-brand-logo">
                <img src="${brand.url}" 
                     alt="${brandName}" 
                     class="cs-calc-brand-logo-img"
                     style="width: ${brand.width}; height: ${brand.height};">
            </span>
        `;
    }
    
    // Fallback to text if no logo found
    return `<span style="font-size: 12px; color: #666;">${brandName}</span>`;
}

// ==================== IP CHECK (Direct with local 5-min cache) ====================
async function checkUserCountry() {
  if (!IP_CHECKER_URL) {
    console.warn('IP_CHECKER_URL not set — skipping country check.');
    return;
  }

  try {
    // Local 5-minute cache to avoid repeated lookups
    const cachedCountry = localStorage.getItem('pcbuildz_country');
    const cacheTime = localStorage.getItem('pcbuildz_country_time');
    const now = Date.now();

    if (cachedCountry && cacheTime && now - parseInt(cacheTime) < 5 * 60 * 1000) {
      console.log('Using cached country:', cachedCountry);
      csCalcIsIndiaUser = cachedCountry === 'IN';
      if (!csCalcIsIndiaUser) restrictExportFeaturesForNonIndia(cachedCountry);
      return;
    }

    // Fetch directly from IPinfo
    const response = await fetch(IP_CHECKER_URL, { cache: 'no-cache' });
    if (!response.ok) {
      console.warn('IP checker returned non-OK response:', response.status);
      return;
    }

    const data = await response.json();
    const country = (data && data.country) ? String(data.country).toUpperCase() : 'UNKNOWN';
    console.log('Detected country:', country);

    // Save to localStorage for 5 minutes
    localStorage.setItem('pcbuildz_country', country);
    localStorage.setItem('pcbuildz_country_time', now.toString());

    csCalcIsIndiaUser = (country === 'IN');

    if (!csCalcIsIndiaUser) {
      restrictExportFeaturesForNonIndia(country);
    } else {
      const overlay = document.getElementById('export-overlay');
      if (overlay) overlay.style.display = 'none';
    }

  } catch (err) {
    console.error('IP check failed:', err);
    csCalcIsIndiaUser = true; // fallback for legitimate users
  }
}

function restrictExportFeaturesForNonIndia(countryCode) {
    // Show friendly overlay and disable PDF/email buttons
    const overlay = document.getElementById('export-overlay');
    const pdfBtn = document.querySelector('.cs-calc-pdf-btn');
    const emailBtn = document.querySelector('.cs-calc-email-btn');

    if (overlay) {
        overlay.style.display = 'flex';
        overlay.innerHTML = `
            <div class="cs-calc-export-overlay-icon">🌐</div>
            <div class="cs-calc-export-overlay-text" style="color:black;">
                This PC Build Price Calculator and Compatibility Checker is intended for the Indian market.
                <br><strong>Exporting or requesting quotations is available to users in India only.</strong>
                <br>You may still browse and verify component compatibility here.
            </div>
        `;
    }

    if (pdfBtn) {
        pdfBtn.disabled = true;
        pdfBtn.setAttribute('aria-disabled', 'true');
        pdfBtn.style.opacity = '0.6';
        pdfBtn.style.cursor = 'not-allowed';
        pdfBtn.title = 'Exporting is available to Indian users only';
        // add data attribute to indicate blocked
        pdfBtn.dataset.csExportBlocked = 'true';
    }

    if (emailBtn) {
        emailBtn.disabled = true;
        emailBtn.setAttribute('aria-disabled', 'true');
        emailBtn.style.opacity = '0.6';
        emailBtn.style.cursor = 'not-allowed';
        emailBtn.title = 'Sending quotations is available to Indian users only';
        emailBtn.dataset.csExportBlocked = 'true';
    }
}

// ==================== UPDATED CATEGORY TABS INITIALIZATION ====================
function initializeCategoryTabs() {
    const pills = document.querySelectorAll('.cs-calc-pill');
    
    pills.forEach(pill => {
        pill.addEventListener('click', function(e) {
            // Don't trigger category change if clicking on dropdown arrow on mobile
            if (window.innerWidth <= 768 && e.target.classList.contains('cs-calc-pill-arrow')) {
                return;
            }
            
            // Only change category if this pill doesn't have a dropdown
            if (!this.classList.contains('has-dropdown')) {
                const category = this.dataset.category;
                currentActiveCategory = category;
                
                // Use the new activateCategoryTab function
                activateCategoryTab(category);
                
                // Update selected filter display for the new category
                updateSelectedFilterDisplay(category);
                
                loadCategoryProducts(category);
            }
        });
    });
}

// ==================== FETCH ALL PRODUCTS (ONCE) ====================
async function fetchAllProductsOnce() {
    // Prevent re-fetching
    if (window.csCalcDataLoaded === true) {
        return;
    }

    const categories = Object.keys(CATEGORY_MAPPING);

    for (let i = 0; i < categories.length; i++) {
        const category = categories[i];
        const sheetName = CATEGORY_MAPPING[category];

        if (!sheetName) continue;

        try {
            const url =
                `https://sheets.googleapis.com/v4/spreadsheets/${SHEET_ID}` +
                `/values/${encodeURIComponent(sheetName)}` +
                `?key=${API_KEY}`;

            const response = await fetch(url);
            const data = await response.json();

            if (!data.values || data.values.length < 2) {
                window.csCalcAllProducts[category] = [];
                continue;
            }

            const headerRow = data.values[0];
            const productRows = data.values.slice(1);
            const columnMap = createColumnMap(headerRow, category);

            const products = [];

            for (let r = 0; r < productRows.length; r++) {
                const row = productRows[r];
                if (!row || !row[0]) continue;

                const product = mapProductData(row, columnMap, category, r);

                if (product && product.name) {
                    products.push(product);
                }
            }

            window.csCalcAllProducts[category] = products;

        } catch (err) {
            console.error('Failed to fetch products for', category, err);
            window.csCalcAllProducts[category] = [];
        }
    }

    window.csCalcDataLoaded = true;
}

// ==================== GOOGLE SHEETS API INTEGRATION ====================
async function loadCategoryProducts(category) {

    // ==================== CACHE FIRST ====================
if (window.csCalcAllProducts && window.csCalcAllProducts[category]) {
    const cachedProducts = window.csCalcAllProducts[category];

    // Convert cached products back into rows format
    const headerRow = Object.keys(cachedProducts[0] || {});
    const productRows = cachedProducts.map(p => Object.values(p));

    // Render from cache
    displayProductsFromAPI([headerRow, ...productRows], category);
    return;
}

    const sheetName = CATEGORY_MAPPING[category];
    if (!sheetName) {
        showError('Unknown category selected');
        return;
    }
    
    const apiUrl = `${API_BASE_URL}${sheetName}?key=${API_KEY}`;
    
    try {
        showLoadingState(category);
        
        const response = await fetch(apiUrl);
        
        if (!response.ok) {
            let errorMessage = '';
            switch (response.status) {
                case 403:
                    errorMessage = 'Access denied. Please ensure:<br>• Google Sheets API is enabled<br>• API key has Sheets API permission<br>• Sheet is shared publicly';
                    break;
                case 404:
                    errorMessage = 'Sheet not found. Check your Sheet ID and tab names.';
                    break;
                case 400:
                    errorMessage = 'Bad request. Check your API key format.';
                    break;
                default:
                    errorMessage = `API Error: ${response.status} ${response.statusText}`;
            }
            throw new Error(errorMessage);
        }
        
        const data = await response.json();
        
        if (data.values && data.values.length > 1) {
            displayProductsFromAPI(data.values, category).then(() => {
                // Restore selections after loading new products
                restoreProductSelections();
            });
        } else {
            showNoProducts(category);
        }
        
    } catch (error) {
        showError(`Failed to load ${category} products:<br>${error.message}`);
    }
}

// ==================== PAGINATION FUNCTIONS ====================
function setupPagination(products, category) {
    currentProducts = products;
    currentPage = 1;
    
    // Set products per page based on screen size
    updateProductsPerPage();
    
    displayCurrentPage();
    restoreProductSelections();
    updatePaginationControls();
}

function updateProductsPerPage() {
    productsPerPage = window.innerWidth <= 880 ? 4 : 9;
}

function displayCurrentPage() {
    const productsContainer = document.querySelector('.cs-calc-products');
    const startIndex = (currentPage - 1) * productsPerPage;
    const endIndex = startIndex + productsPerPage;
    const paginatedProducts = currentProducts.slice(startIndex, endIndex);
    
    // Store the current scroll position before updating
    const scrollPosition = window.pageYOffset;
    
    productsContainer.innerHTML = paginatedProducts.join('');
    
    // CRITICAL FIX: After rendering products, restore the visual selection state
    restoreProductSelections();
    
    // Restore scroll position to prevent jumping
    window.scrollTo(0, scrollPosition);
    
    // Show/hide pagination based on number of products
    const paginationContainer = document.getElementById('pagination-container');
    if (currentProducts.length > productsPerPage) {
        paginationContainer.style.display = 'flex';
    } else {
        paginationContainer.style.display = 'none';
    }
}

// NEW FUNCTION: Restore visual selection state after pagination
function restoreProductSelections() {
    // Loop through all categories
    Object.entries(selectedProducts).forEach(([category, product]) => {
        if (product) {
            // Find all cards for this category
            const cards = document.querySelectorAll(`.cs-calc-card[data-category="${category}"]`);
            cards.forEach(card => {
                // Check if this card is the selected product
                if (card.dataset.productId === product.id) {
                    // Add selected class
                    card.classList.add('cs-calc-selected');
                    
                    // Update button text and class
                    const button = card.querySelector('.cs-calc-btn');
                    if (button) {
                        button.textContent = 'DESELECT';
                        button.classList.add('cs-calc-selected-btn');
                    }
                    
                    // Update quantity display if applicable
                    if (['RAM', 'Storage (SSD)', 'Storage (HDD)', 'Case Fan', 'Monitor'].includes(category)) {
                        const quantityDisplay = card.querySelector('.cs-calc-quantity-display');
                        if (quantityDisplay) {
                            quantityDisplay.textContent = productQuantities[category] || 1;
                        }
                    }
                }
            });
        }
    });
}

function updatePaginationControls() {
    const totalPages = Math.ceil(currentProducts.length / productsPerPage);
    const pageInfo = document.getElementById('page-info');
    const prevBtn = document.getElementById('prev-btn');
    const nextBtn = document.getElementById('next-btn');
    
    pageInfo.textContent = `Page ${currentPage} of ${totalPages}`;
    
    // Disable/enable buttons
    prevBtn.disabled = currentPage === 1;
    nextBtn.disabled = currentPage === totalPages || totalPages === 0;
}

// ==================== ENHANCED PAGINATION SCROLL ====================
function scrollToFirstProductCard() {
    // Wait a brief moment for the DOM to update with new products
    setTimeout(() => {
        const firstProductCard = document.querySelector('.cs-calc-card');
        if (firstProductCard) {
            const elementRect = firstProductCard.getBoundingClientRect();
            const absoluteElementTop = elementRect.top + window.pageYOffset;
            
            // Calculate position to place the card in the middle of the viewport
            const middle = absoluteElementTop - (window.innerHeight / 2) + (elementRect.height / 2);
            
            window.scrollTo({
                top: middle,
                behavior: 'smooth'
            });
        }
    }, 100);
}

function goToPrevPage() {
    if (currentPage > 1) {
        currentPage--;
        displayCurrentPage();
        updatePaginationControls();
        scrollToFirstProductCard();
    }
}

function goToNextPage() {
    const totalPages = Math.ceil(currentProducts.length / productsPerPage);
    if (currentPage < totalPages) {
        currentPage++;
        displayCurrentPage();
        updatePaginationControls();
        scrollToFirstProductCard();
    }
}

// Update products per page on window resize
window.addEventListener('resize', function() {
    if (currentProducts.length > 0) {
        const oldProductsPerPage = productsPerPage;
        updateProductsPerPage();
        
        // Only update if products per page changed
        if (oldProductsPerPage !== productsPerPage) {
            // Recalculate current page to show the same products
            const firstVisibleIndex = (currentPage - 1) * oldProductsPerPage;
            currentPage = Math.floor(firstVisibleIndex / productsPerPage) + 1;
            
            displayCurrentPage();
            updatePaginationControls();
        }
    }
});

// ==================== PRODUCT DISPLAY FUNCTIONS ====================
function displayProductsFromAPI(rows, category) {
    return new Promise((resolve) => {
        const productsContainer = document.querySelector('.cs-calc-products');
        
        const headerRow = rows[0];
        const productRows = rows.slice(1);
        
        if (productRows.length === 0) {
            showNoProducts(category);
            resolve();
            return;
        }
        
        // Create column mapping based on headers
        const columnMap = createColumnMap(headerRow, category);
        
        let productsHTML = [];
        let filteredCount = 0;
        
        productRows.forEach((row, index) => {
            if (!row || row.length === 0 || !row[0]) return;
            
            const product = mapProductData(row, columnMap, category, index);
            
            if (!product.name || product.price === 0) {
                return;
            }
            
            // Apply filters
if (!passesFilters(product, category)) {
    console.log(`Filtered out ${product.name} - Category: ${category}, CPU selected: ${selectedProducts['CPU']?.name}, MB selected: ${selectedProducts['Motherboard']?.name}`);
    return;
}
            
            productsHTML.push(createProductCard(product, category));
            filteredCount++;
        });
        
        if (filteredCount === 0) {
            productsContainer.innerHTML = showNoFilteredProducts(category);
            document.getElementById('pagination-container').style.display = 'none';
            resolve();
        } else {
            setupPagination(productsHTML, category);
            resolve();
        }
    });
}

function passesFilters(product, category) {
    const filter = selectedFilters[category];
    
    // Apply auto-filter based on other selected components (always apply this)
    if (category === 'Motherboard' && selectedProducts['CPU']) {
        const passesAutoFilter = passesMotherboardAutoFilter(product);
        if (!passesAutoFilter) return false;
    }
    
    if (category === 'CPU' && selectedProducts['Motherboard']) {
        const passesAutoFilter = passesCPUAutoFilter(product);
        if (!passesAutoFilter) return false;
    }
    
    // If no manual filter is selected, just return the auto-filter result
    if (!filter) {
        // For motherboards, we already applied auto-filter above
        if (category === 'Motherboard') return true;
        // For CPUs, we already applied auto-filter above
        if (category === 'CPU') return true;
        return true;
    }
    
    // Apply manual filter logic (only runs if there's a manual filter)
    switch(category) {
        
        case 'GPU':
            // FIXED: Use exact matching for GPU models to avoid "5060" matching "5060 Ti"
            if (filter === 'RTX 5060') {
                return product.name && (
                    product.name.includes('RTX 5060') && 
                    !product.name.includes('RTX 5060 Ti')
                );
            } else if (filter === 'RTX 5060 Ti') {
                return product.name && product.name.includes('RTX 5060 Ti');
            } else if (filter === 'RTX 5070') {
                return product.name && (
                    product.name.includes('RTX 5070') && 
                    !product.name.includes('RTX 5070 Ti')
                );
            } else if (filter === 'RTX 5070 Ti') {
                return product.name && product.name.includes('RTX 5070 Ti');
            } else if (filter === 'RTX 5080') {
                return product.name && product.name.includes('RTX 5080');
            } else if (filter === 'RTX 5090') {
                return product.name && product.name.includes('RTX 5090');
            } else if (filter === 'RTX 5050') {
                return product.name && product.name.includes('RTX 5050');    
            }
            return true;
        
        case 'Motherboard':
            // Auto-filter already applied above, now apply manual filter
            // Check if motherboard has the specified chipset
            const hasChipset = product.chipset && 
                product.chipset.toLowerCase().includes(filter.toLowerCase());
            
            // Also check name and specs as fallback
            const hasInNameOrSpecs = product.name.toLowerCase().includes(filter.toLowerCase()) ||
                                    product.specs?.toLowerCase().includes(filter.toLowerCase()) ||
                                    product.brand?.toLowerCase().includes(filter.toLowerCase());
            
            // If filter is a chipset (H610, B760, etc.), check socket compatibility
            if (filter && selectedProducts['CPU']) {
                const cpuSocket = selectedProducts['CPU'].socket?.toUpperCase() || '';
                
                // Map chipsets to their compatible sockets
                const chipsetSocketMap = {
                    'h610': 'LGA1700',
                    'b760': 'LGA1700',
                    'z790': 'LGA1700',
                    'h770': 'LGA1700',
                    'b860': 'LGA1851',
                    'z890': 'LGA1851',
                    'b650': 'AM5',
                    'x670': 'AM5',
                    'a620': 'AM5',
                    'b850': 'AM5',
                    'x870': 'AM5'
                };
                
                const filterLower = filter.toLowerCase();
                const expectedSocket = chipsetSocketMap[filterLower];
                
                // If we know what socket this chipset needs, check if CPU has that socket
                if (expectedSocket && cpuSocket !== expectedSocket) {
                    return false; // Chipset not compatible with CPU socket
                }
            }
            
            return hasChipset || hasInNameOrSpecs;
        
        case 'CPU':
            // Auto-filter already applied above, now apply manual filter
            const hasBrand = product.brand && product.brand.toLowerCase().includes(filter.toLowerCase());
            
            // If motherboard is selected, check brand compatibility with manual filter
            if (selectedProducts['Motherboard']) {
                const motherboardBrand = selectedProducts['Motherboard'].brand?.toLowerCase() || '';
                const motherboardChipset = selectedProducts['Motherboard'].chipset?.toLowerCase() || '';
                
                let isIntelMotherboard = false;
                let isAMDMotherboard = false;
                
                // Determine motherboard brand from chipset or brand field
                if (motherboardChipset.includes('h610') || motherboardChipset.includes('b760') || 
                    motherboardChipset.includes('z790') || motherboardChipset.includes('h770') ||
                    motherboardChipset.includes('b860') || motherboardChipset.includes('z890')) {
                    isIntelMotherboard = true;
                } else if (motherboardChipset.includes('b650') || motherboardChipset.includes('b850') || 
                           motherboardChipset.includes('x870') || motherboardChipset.includes('x670') ||
                           motherboardChipset.includes('a620')) {
                    isAMDMotherboard = true;
                }
                // Fallback to brand field
                else if (motherboardBrand.includes('intel')) {
                    isIntelMotherboard = true;
                } else if (motherboardBrand.includes('amd')) {
                    isAMDMotherboard = true;
                }
                
                // Check if manual filter conflicts with motherboard brand
                if (filter.toLowerCase() === 'intel' && isAMDMotherboard) {
                    return false; // Intel CPU filter + AMD motherboard = incompatible
                }
                if (filter.toLowerCase() === 'amd' && isIntelMotherboard) {
                    return false; // AMD CPU filter + Intel motherboard = incompatible
                }
            }
            
            return hasBrand;
        
        case 'RAM':
            // Filter by name containing size
            return product.name && product.name.toLowerCase().includes(filter.toLowerCase());
        
        case 'Storage (SSD)':
        case 'Storage (HDD)':
            // Filter by name containing size
            return product.name && product.name.toLowerCase().includes(filter.toLowerCase());
        
        case 'PSU':
            // Filter by wattage
            return product.wattage && product.wattage.toString().includes(filter);
        
        case 'Cooling':
            // Filter by cooler type
            return product.coolerType && product.coolerType.toLowerCase() === filter.toLowerCase();
        
        case 'Case':
            // Filter by case type
            return product.brand && product.brand.toLowerCase().includes(filter.toLowerCase());
        
        case 'Monitor': {
    // Combine name + specs to detect size safely
    const sizeText = ((product.name || '') + ' ' + (product.specs || '')).toLowerCase();

    /*
      This regex detects:
      22 inch
      22 Inch
      22-inch
      22-Inch
    */
    const match = sizeText.match(/(\d{2})\s*-?\s*inch/);

    // If no size detected, hide the product
    if (!match) return false;

    const monitorSize = parseInt(match[1], 10);

    // SPECIAL CASE: 34-inch+
    if (filter === '34') {
        return monitorSize >= 34;
    }

    // All other filters: exact match (22, 24, 27, 32)
    return monitorSize === parseInt(filter, 10);
}
        
        case 'Keyboard':
        case 'Mouse':
        case 'Headset':
            // Filter by connectivity type
            return product.connectivity && product.connectivity.toLowerCase().includes(filter.toLowerCase());    

        case 'Accessories':
            // Filter by product type
            if (filter) {
                return product.productType && product.productType.toLowerCase().includes(filter.toLowerCase());
            }
            return true;            

        default:
            return true;
    }
}

// CORRECTED FUNCTION: Auto-filter motherboards based on selected CPU using SOCKET values
function passesMotherboardAutoFilter(motherboard) {
    if (!selectedProducts['CPU']) {
        return true; // Show all motherboards if no CPU is selected
    }
    
    const cpuSocket = selectedProducts['CPU'].socket?.toUpperCase() || '';
    const motherboardSocket = motherboard.socket?.toUpperCase() || '';
    
    // If either doesn't have socket info, show all (fallback to brand filtering)
    if (!cpuSocket || !motherboardSocket) {
        const cpuBrand = selectedProducts['CPU'].brand?.toLowerCase() || '';
        const motherboardBrand = motherboard.brand?.toLowerCase() || '';
        const motherboardChipset = motherboard.chipset?.toLowerCase() || '';
        
        // Fallback to brand/chipset filtering when socket info is missing
        if (cpuBrand.includes('intel')) {
            return motherboardBrand.includes('intel') || 
                   motherboardChipset.includes('intel') ||
                   motherboardChipset.includes('h610') || 
                   motherboardChipset.includes('b760') ||
                   motherboardChipset.includes('z790') ||
                   motherboardChipset.includes('h770') ||
                   motherboardChipset.includes('b860') ||
                   motherboardChipset.includes('z890');
        } else if (cpuBrand.includes('amd')) {
            return motherboardBrand.includes('amd') || 
                   motherboardChipset.includes('amd') ||
                   motherboardChipset.includes('b650') || 
                   motherboardChipset.includes('x670') ||
                   motherboardChipset.includes('a620') ||
                   motherboardChipset.includes('b850') ||
                   motherboardChipset.includes('x870');
        }
        return true;
    }
    
    // PRIMARY FILTER: Match sockets exactly
    return cpuSocket === motherboardSocket;
}

// UPDATED FUNCTION: Auto-filter CPUs based on selected motherboard using SOCKET values
function passesCPUAutoFilter(cpu) {
    if (!selectedProducts['Motherboard']) {
        return true; // Show all CPUs if no motherboard is selected
    }
    
    const motherboardSocket = selectedProducts['Motherboard'].socket?.toUpperCase() || '';
    const cpuSocket = cpu.socket?.toUpperCase() || '';
    
    // PRIMARY FILTER: Match sockets exactly
    if (motherboardSocket && cpuSocket) {
        return cpuSocket === motherboardSocket;
    }
    
    // If socket info is missing, fallback to brand filtering
    const motherboardBrand = selectedProducts['Motherboard'].brand?.toLowerCase() || '';
    const motherboardChipset = selectedProducts['Motherboard'].chipset?.toLowerCase() || '';
    const cpuBrand = cpu.brand?.toLowerCase() || '';
    
    // Fallback logic when socket info is missing
    if (motherboardBrand.includes('intel') || motherboardChipset.includes('intel') ||
        motherboardChipset.includes('h610') || motherboardChipset.includes('b760') ||
        motherboardChipset.includes('z790') || motherboardChipset.includes('h770') ||
        motherboardChipset.includes('b860') || motherboardChipset.includes('z890')) {
        return cpuBrand.includes('intel');
    } else if (motherboardBrand.includes('amd') || motherboardChipset.includes('amd') ||
               motherboardChipset.includes('b650') || motherboardChipset.includes('x670') ||
               motherboardChipset.includes('a620') || motherboardChipset.includes('b850') ||
               motherboardChipset.includes('x870')) {
        return cpuBrand.includes('amd');
    }
    
    return true;
}

function showNoFilteredProducts(category) {
    const filter = selectedFilters[category];
    const filterLabel = CATEGORY_FILTERS[category]?.find(f => f.value === filter)?.label || filter;
    
    // ==================== CPU → MOTHERBOARD FILTERING ====================
if (category === 'Motherboard' && selectedProducts['CPU']) {
    const cpuBrand = selectedProducts['CPU'].brand?.toLowerCase() || '';
    const cpuSocket = selectedProducts['CPU'].socket?.toUpperCase() || '';
    const cpuName = selectedProducts['CPU'].name || '';
    
    // Get CPU brand for display (Intel/AMD)
    let cpuBrandDisplay = 'Processor';
    if (cpuBrand.includes('intel')) cpuBrandDisplay = 'Intel Processor';
    if (cpuBrand.includes('amd')) cpuBrandDisplay = 'AMD Processor';
    
    if (filter) {
        const filterLower = filter.toLowerCase();
        
        // Map chipsets to brands
        const chipsetBrandMap = {
            'h610': 'intel', 'b760': 'intel', 'z790': 'intel', 'h770': 'intel',
            'b860': 'intel', 'z890': 'intel',
            'b650': 'amd', 'x670': 'amd', 'a620': 'amd', 'b850': 'amd', 'x870': 'amd'
        };
        
        const chipsetBrand = chipsetBrandMap[filterLower];
        
        // Check if chipset brand matches CPU brand
        if (chipsetBrand && !cpuBrand.includes(chipsetBrand)) {
            const targetBrand = chipsetBrand === 'intel' ? 'Intel' : 'AMD';
            return `
                <div style="text-align: center; padding: 60px; color: #666; grid-column: 1 / -1;">
                    <div style="font-size: 16px; margin-bottom: 10px;">You have selected an <strong>${cpuBrandDisplay}</strong> with <strong>${cpuSocket}</strong> Socket</div>
                    <div style="font-size: 14px;">To view ${targetBrand} Motherboards, please select a ${targetBrand} Processor</div>
                    <div style="font-size: 12px; margin-top: 10px; color: #888;">Selected CPU: ${cpuName}</div>
                </div>
            `;
        }
        
        // Check socket compatibility for specific chipsets
        const chipsetSocketMap = {
            'h610': 'LGA1700', 'b760': 'LGA1700', 'z790': 'LGA1700', 'h770': 'LGA1700',
            'b860': 'LGA1851', 'z890': 'LGA1851',
            'b650': 'AM5', 'x670': 'AM5', 'a620': 'AM5', 'b850': 'AM5', 'x870': 'AM5'
        };
        
        const requiredSocket = chipsetSocketMap[filterLower];
        if (requiredSocket && cpuSocket !== requiredSocket) {
            return `
                <div style="text-align: center; padding: 60px; color: #666; grid-column: 1 / -1;">
                    <div style="font-size: 16px; margin-bottom: 10px;">You have selected an <strong>${cpuBrandDisplay}</strong> with <strong>${cpuSocket}</strong> Socket</div>
                    <div style="font-size: 14px;">${filter.toUpperCase()} motherboards require ${requiredSocket} socket processors</div>
                    <div style="font-size: 12px; margin-top: 10px; color: #888;">Selected CPU: ${cpuName}</div>
                    <div style="font-size: 12px; margin-top: 5px; color: #888;">Please select a different CPU or Motherboard</div>
                </div>
            `;
        }
    }
    
    // General socket-based filtering message
    return `
        <div style="text-align: center; padding: 60px; color: #666; grid-column: 1 / -1;">
            <div style="font-size: 16px; margin-bottom: 10px;">You have selected an <strong>${cpuBrandDisplay}</strong> with <strong>${cpuSocket}</strong> Socket</div>
            <div style="font-size: 14px;">No compatible Motherboards found for this processor socket</div>
            <div style="font-size: 12px; margin-top: 10px; color: #888;">Selected CPU: ${cpuName}</div>
            <div style="font-size: 12px; margin-top: 5px; color: #888;">Please select a different CPU or Motherboard</div>
        </div>
    `;
}
    
    // ==================== MOTHERBOARD → CPU FILTERING ====================
if (category === 'CPU' && selectedProducts['Motherboard']) {
    const motherboardChipset = selectedProducts['Motherboard'].chipset?.toUpperCase() || '';
    const motherboardSocket = selectedProducts['Motherboard'].socket?.toUpperCase() || '';
    const motherboardName = selectedProducts['Motherboard'].name || '';
    const motherboardBrand = selectedProducts['Motherboard'].brand?.toLowerCase() || '';
    
    // Determine motherboard brand for display
    let motherboardBrandDisplay = '';
    let motherboardType = 'Motherboard';
    
    if (motherboardBrand.includes('intel') || motherboardChipset.toLowerCase().includes('intel') ||
        motherboardChipset.includes('H610') || motherboardChipset.includes('B760') ||
        motherboardChipset.includes('Z790') || motherboardChipset.includes('H770') ||
        motherboardChipset.includes('B860') || motherboardChipset.includes('Z890')) {
        motherboardBrandDisplay = 'Intel';
        motherboardType = `${motherboardChipset || 'Intel'} Motherboard`;
    } else if (motherboardBrand.includes('amd') || motherboardChipset.toLowerCase().includes('amd') ||
               motherboardChipset.includes('B650') || motherboardChipset.includes('X670') ||
               motherboardChipset.includes('A620') || motherboardChipset.includes('B850') ||
               motherboardChipset.includes('X870')) {
        motherboardBrandDisplay = 'AMD';
        motherboardType = `${motherboardChipset || 'AMD'} Motherboard`;
    }
    
    // Check if there's a manual filter
    if (filter) {
        const filterLower = filter.toLowerCase();
        
        // For Intel motherboard + AMD CPU filter
        if (motherboardBrandDisplay === 'Intel' && filterLower === 'amd') {
            return `
                <div style="text-align: center; padding: 60px; color: #666; grid-column: 1 / -1;">
                    <div style="font-size: 16px; margin-bottom: 10px;">You have selected an <strong>${motherboardBrandDisplay} ${motherboardType}</strong> with <strong>${motherboardSocket}</strong> Socket</div>
                    <div style="font-size: 14px;">To view AMD Processors, please select an AMD-compatible Motherboard</div>
                    <div style="font-size: 12px; margin-top: 10px; color: #888;">Selected Motherboard: ${motherboardName}</div>
                </div>
            `;
        }
        
        // For AMD motherboard + Intel CPU filter
        if (motherboardBrandDisplay === 'AMD' && filterLower === 'intel') {
            return `
                <div style="text-align: center; padding: 60px; color: #666; grid-column: 1 / -1;">
                    <div style="font-size: 16px; margin-bottom: 10px;">You have selected an <strong>${motherboardBrandDisplay} ${motherboardType}</strong> with <strong>${motherboardSocket}</strong> Socket</div>
                    <div style="font-size: 14px;">To view Intel Processors, please select an Intel-compatible Motherboard</div>
                    <div style="font-size: 12px; margin-top: 10px; color: #888;">Selected Motherboard: ${motherboardName}</div>
                </div>
            `;
        }
        
        // For socket mismatch with specific CPU filter
        if (filterLower !== 'intel' && filterLower !== 'amd') {
            // This handles if someone tries to filter CPUs by model/series when motherboard is selected
            // We still need to check socket compatibility
            if (motherboardSocket) {
                return `
                    <div style="text-align: center; padding: 60px; color: #666; grid-column: 1 / -1;">
                        <div style="font-size: 16px; margin-bottom: 10px;">You have selected a <strong>${motherboardType}</strong> with <strong>${motherboardSocket}</strong> Socket</div>
                        <div style="font-size: 14px;">No compatible ${filter} Processors found for this motherboard socket</div>
                        <div style="font-size: 12px; margin-top: 10px; color: #888;">Selected Motherboard: ${motherboardName}</div>
                        <div style="font-size: 12px; margin-top: 5px; color: #888;">Please select a different motherboard or check compatibility</div>
                    </div>
                `;
            }
        }
    }
    
    // General socket-based filtering message (when no filter or "All CPUs" filter)
    const brandText = motherboardBrandDisplay ? `${motherboardBrandDisplay} ` : '';
    const chipsetText = motherboardChipset ? `${motherboardChipset} ` : '';
    
    return `
        <div style="text-align: center; padding: 60px; color: #666; grid-column: 1 / -1;">
            <div style="font-size: 16px; margin-bottom: 10px;">You have selected a <strong>${brandText}${chipsetText}Motherboard</strong> with <strong>${motherboardSocket}</strong> Socket</div>
            <div style="font-size: 14px;">No compatible Processors found for this motherboard socket</div>
            <div style="font-size: 12px; margin-top: 10px; color: #888;">Selected Motherboard: ${motherboardName}</div>
            <div style="font-size: 12px; margin-top: 5px; color: #888;">Please select a different motherboard or check compatibility</div>
        </div>
    `;
}
    
    // ==================== DEFAULT MESSAGE ====================
    return `
        <div style="text-align: center; padding: 60px; color: #666; grid-column: 1 / -1;">
            <div style="font-size: 16px; margin-bottom: 10px;">No ${category} products found for "${filterLabel}"</div>
            <div style="font-size: 12px;">Try selecting a different filter or check back later</div>
        </div>
    `;
}

// Create column mapping for each category
function createColumnMap(headers, category) {
    const map = {};
    
    headers.forEach((header, index) => {
        const normalizedHeader = header.trim().toLowerCase().replace(/[^a-z0-9]/g, '');
        
        switch(normalizedHeader) {
            case 'id': map.id = index; break;
            case 'name': map.name = index; break;
            case 'price': map.price = index; break;
            case 'brand': map.brand = index; break;
            case 'imageurl': map.imageUrl = index; break;
            case 'socket': map.socket = index; break;
            case 'formfactor': map.formFactor = index; break;
            case 'ramtype': map.ramType = index; break;
            case 'wattage': map.wattage = index; break;
            case 'specs': map.specs = index; break;
            case 'coolerheight': map.coolerHeight = index; break;
            case 'coolertype': map.coolerType = index; break;
            case 'radiatorsize': map.radiatorSize = index; break;
            case 'gpulength': map.gpuLength = index; break;
            case 'maxcoolerheight': map.maxCoolerHeight = index; break;
            case 'maxgpulength': map.maxGpuLength = index; break;
            case 'fanslots': map.fanSlots = index; break;
            case 'fansize': map.fanSize = index; break;
            case 'fancount': map.fanCount = index; break;
            case 'ssdtype': map.ssdType = index; break;
            case 'ssdslots': map.ssdSlots = index; break;
            case 'ramslots': map.ramSlots = index; break;
            case 'hddslots': map.hddSlots = index; break;
            case 'ramcount': map.ramCount = index; break;
            case 'preinstalledfans': map.preInstalledFans = index; break;
            case 'maxradiatorsize': map.maxRadiatorSize = index; break;
            case 'connectivity': map.connectivity = index; break;
            case 'chipset': map.chipset = index; break; // NEW: Chipset field for motherboards
            case 'hasintegratedgpu': map.hasIntegratedGPU = index; break; // NEW: Has Integrated GPU field
            case 'producttype': map.productType = index; break;
        }
    });
    
    return map;
}

// Map product data based on column mapping
function mapProductData(row, columnMap, category, index) {
    const getValue = (key) => {
        const index = columnMap[key];
        return index !== undefined && row[index] ? row[index] : '';
    };
    
    // Convert Google Drive URL to direct image URL
    const originalImageUrl = getValue('imageUrl');
    const convertedImageUrl = convertGoogleDriveUrl(originalImageUrl);
    
    return {
        id: getValue('id') || `auto-${category}-${index}`,
        name: getValue('name') || 'Unnamed Product',
        price: parseInt(getValue('price')) || 0,
        brand: getValue('brand'),
        imageUrl: convertedImageUrl, // Use converted URL
        socket: getValue('socket'),
        formFactor: getValue('formFactor'),
        ramType: getValue('ramType'),
        wattage: getValue('wattage'),
        specs: getValue('specs'),
        coolerHeight: getValue('coolerHeight'),
        coolerType: getValue('coolerType'),
        radiatorSize: getValue('radiatorSize'),
        gpuLength: getValue('gpuLength'),
        maxCoolerHeight: getValue('maxCoolerHeight'),
        maxGpuLength: getValue('maxGpuLength'),
        fanSlots: getValue('fanSlots'),
        fanSize: getValue('fanSize'),
        fanCount: getValue('fanCount'),
        ssdType: getValue('ssdType'),
        ssdSlots: getValue('ssdSlots'),
        ramSlots: getValue('ramSlots'),
        hddSlots: getValue('hddSlots'),
        ramCount: getValue('ramCount'),
        preInstalledFans: getValue('preInstalledFans'),
        maxRadiatorSize: getValue('maxRadiatorSize'),
        connectivity: getValue('connectivity'),
        chipset: getValue('chipset'), // NEW: Chipset data for motherboards
        productType: getValue('productType'), // NEW: Product type for accessories
        hasIntegratedGPU: getValue('hasIntegratedGPU') || 'Yes' // NEW: Has Integrated GPU data
    };
}

function showLoadingState(category) {
    const productsContainer = document.querySelector('.cs-calc-products');
    productsContainer.innerHTML = `
        <div style="text-align: center; padding: 60px; color: #666;">
            <div style="font-size: 16px; margin-bottom: 10px;">Loading ${category} products...</div>
        </div>
    `;
    document.getElementById('pagination-container').style.display = 'none';
}

function showError(message) {
    const productsContainer = document.querySelector('.cs-calc-products');
    productsContainer.innerHTML = `
        <div style="text-align: center; padding: 40px; color: #ef4444;">
            <div style="font-size: 16px; margin-bottom: 10px;">⚠️ API Error</div>
            <div style="font-size: 14px; line-height: 1.4;">${message}</div>
        </div>
    `;
    document.getElementById('pagination-container').style.display = 'none';
}

function showNoProducts(category) {
    const productsContainer = document.querySelector('.cs-calc-products');
    productsContainer.innerHTML = `
        <div style="text-align: center; padding: 60px; color: #666;">
            <div style="font-size: 16px; margin-bottom: 10px;">No ${category} products found</div>
            <div style="font-size: 12px;">Add products to your Google Sheet</div>
        </div>
    `;
    document.getElementById('pagination-container').style.display = 'none';
}

function createProductCard(product, category) {
    const specs = product.specs ? product.specs.split(',').map(spec => spec.trim()).filter(spec => spec) : [];
    
    const compatibilityTags = [];
    
    // Only show socket for CPU and Motherboard
    if (product.socket && (category === 'CPU' || category === 'Motherboard')) {
        compatibilityTags.push(product.socket);
    }
    
    // Show chipset for Motherboard
    //if (product.chipset && category === 'Motherboard') {
    //    compatibilityTags.push(product.chipset);
    //}
    
    // Only show form factor for Motherboard and Case
    if (product.formFactor && (category === 'Motherboard' || category === 'Case')) {
        compatibilityTags.push(product.formFactor);
    }
    
    // Only show RAM type for Motherboard and RAM
    if (product.ramType && (category === 'Motherboard' || category === 'RAM')) {
        compatibilityTags.push(product.ramType);
    }
    
    // Only show wattage for PSU
    if (product.wattage && category === 'PSU') {
        compatibilityTags.push(`${product.wattage}W`);
    }
    
    // Show cooler type for Cooling (with proper naming)
    if (product.coolerType && category === 'Cooling') {
        const coolerDisplayName = product.coolerType === 'Air' ? 'Air Cooler' : 
                                 product.coolerType === 'Liquid' ? 'Liquid Cooler' : product.coolerType;
        compatibilityTags.push(coolerDisplayName);
    }
    
    // Show radiator size for Liquid Coolers
    if (product.radiatorSize && category === 'Cooling' && product.coolerType === 'Liquid') {
        compatibilityTags.push(`${product.radiatorSize}mm Radiator`);
    }
    
    // Show max radiator size for Case
    if (product.maxRadiatorSize && category === 'Case') {
        compatibilityTags.push(`Max Radiator: ${product.maxRadiatorSize}mm`);
    }
    
    // Show fan size for Case Fan
    if (product.fanSize && category === 'Case Fan') {
        compatibilityTags.push(`${product.fanSize}mm`);
    }
    
    // Show SSD type for Storage (SSD)
    if (product.ssdType && category === 'Storage (SSD)') {
        compatibilityTags.push(product.ssdType);
    }
    
    // Show pre-installed fans for Case (with proper pluralization)
    if (product.preInstalledFans && category === 'Case') {
        const fanCount = parseInt(product.preInstalledFans) || 0;
        if (fanCount > 0) {
            const fanText = pluralize(fanCount, 'Pre-installed Fan', 'Pre-installed Fans');
            compatibilityTags.push(`${fanCount} ${fanText}`);
        }
    }
    
    // Show RAM stick count for RAM (with proper pluralization)
    if (product.ramCount && category === 'RAM') {
        const stickCount = parseInt(product.ramCount) || 0;
        if (stickCount > 0) {
            const stickText = pluralize(stickCount, 'Stick', 'Sticks');
            compatibilityTags.push(`${stickCount} ${stickText}`);
        }
    }
    
    // Show connectivity for Keyboard, Mouse, Headset
    if (product.connectivity && ['Keyboard', 'Mouse', 'Headset'].includes(category)) {
        compatibilityTags.push(product.connectivity);
    }
    
    // Add regular specs
    const allTags = [...specs, ...compatibilityTags];
    
    // Check if this product is currently selected
    const isSelected = selectedProducts[category]?.id === product.id;
    
    // Check if this category supports quantity controls
    const supportsQuantity = ['RAM', 'Storage (SSD)', 'Storage (HDD)', 'Case Fan', 'Monitor'].includes(category);
    const currentQuantity = productQuantities[category] || 1;
    
    // Get brand logo
    const brandLogo = product.brand ? getBrandLogo(product.brand) : '';
    
    return `
        <article class="cs-calc-card ${isSelected ? 'cs-calc-selected' : ''}" 
                 data-product-id="${product.id}" 
                 data-category="${category}" 
                 data-price="${product.price}"
                 data-socket="${product.socket}"
                 data-form-factor="${product.formFactor}"
                 data-ram-type="${product.ramType}"
                 data-wattage="${product.wattage}"
                 data-image-url="${product.imageUrl}"
                 data-cooler-height="${product.coolerHeight}"
                 data-cooler-type="${product.coolerType}"
                 data-radiator-size="${product.radiatorSize}"
                 data-gpu-length="${product.gpuLength}"
                 data-max-cooler-height="${product.maxCoolerHeight}"
                 data-max-gpu-length="${product.maxGpuLength}"
                 data-fan-slots="${product.fanSlots}"
                 data-fan-size="${product.fanSize}"
                 data-fan-count="${product.fanCount}"
                 data-ssd-type="${product.ssdType}"
                 data-ssd-slots="${product.ssdSlots}"
                 data-ram-slots="${product.ramSlots}"
                 data-hdd-slots="${product.hddSlots}"
                 data-ram-count="${product.ramCount}"
                 data-pre-installed-fans="${product.preInstalledFans}"
                 data-max-radiator-size="${product.maxRadiatorSize}"
                 data-connectivity="${product.connectivity}"
                 data-chipset="${product.chipset}"
                 data-has-integrated-gpu="${product.hasIntegratedGPU}">
            <div class="cs-calc-card-top">
                <div class="cs-calc-title">${product.name}</div>
                ${brandLogo || ''}
            </div>
            <div class="cs-calc-meta">
                ${allTags.map(tag => `<span class="cs-calc-tag">${tag}</span>`).join('')}
            </div>
            <div class="cs-calc-bottom">
                <div>
                    <div class="cs-calc-price">₹${product.price.toLocaleString()}</div>
                </div>
                ${supportsQuantity ? `
                    <div class="cs-calc-quantity-controls">
                        <button class="cs-calc-quantity-btn" 
                                onclick="event.stopPropagation(); handleQuantityChange('${category}', -1, '${product.id}')"
                                title="Please select product before decreasing Quantity">-</button>
                        <div class="cs-calc-quantity-display">${isSelected ? currentQuantity : 1}</div>
                        <button class="cs-calc-quantity-btn" 
                                onclick="event.stopPropagation(); handleQuantityChange('${category}', 1, '${product.id}')"
                                title="Please select product before increasing Quantity">+</button>
                    </div>
                ` : ''}
                <button class="cs-calc-btn ${isSelected ? 'cs-calc-selected-btn' : ''}" onclick="selectProduct(this)">
                    ${isSelected ? 'DESELECT' : 'SELECT'}
                </button>
            </div>
        </article>
    `;
}

// ==================== UPDATED QUANTITY CONTROL FUNCTIONS ====================
function handleQuantityChange(category, change, productId) {
    // Check if product is selected before allowing quantity change
    if (selectedProducts[category]?.id !== productId) {
        const clickedCard = document.querySelector(`.cs-calc-card[data-product-id="${productId}"]`);
        if (clickedCard) {
            showTooltipMessage('Please select product before changing quantity', clickedCard);
        }
        return;
    }
    
    // Ensure we're working with the currently selected product
    const currentQty = productQuantities[category] || 1;
    const newQty = Math.max(1, currentQty + change);
    
    if (newQty !== currentQty) {
        productQuantities[category] = newQty;
        
        // Update the quantity display in ALL product cards for this category
        updateAllQuantityDisplays(category, newQty);
        
        // Update build summary
        updateBuildSummaryQuantity(category, newQty);
        
        // Update total price
        updateTotalPrice();
        
        // Check compatibility when quantity changes
        checkCompatibility();
    }
}

function showTooltipMessage(message, targetElement) {
    // Remove any existing tooltip
    const existingTooltip = document.getElementById('quantity-tooltip');
    if (existingTooltip) {
        existingTooltip.remove();
    }

    // Create new tooltip
    const tooltip = document.createElement('div');
    tooltip.id = 'quantity-tooltip';
    tooltip.textContent = message;
    tooltip.style.cssText = `
        position: absolute;
        background: rgba(0, 0, 0, 0.9);
        color: white;
        padding: 8px 12px;
        border-radius: 6px;
        font-size: 12px;
        font-weight: 600;
        z-index: 10000;
        pointer-events: none;
        transition: opacity 0.3s ease;
        text-align: center;
        max-width: 200px;
        box-shadow: 0 2px 8px rgba(0,0,0,0.3);
    `;

    // Position the tooltip over the target element (centered)
    const rect = targetElement.getBoundingClientRect();
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
    
    tooltip.style.top = `${rect.top + scrollTop + (rect.height / 2) - 20}px`;
    tooltip.style.left = `${rect.left + scrollLeft + (rect.width / 2)}px`;
    tooltip.style.transform = 'translate(-50%, -50%)';

    document.body.appendChild(tooltip);

    // Show tooltip
    tooltip.style.opacity = '1';

    // Hide tooltip after 2 seconds
    setTimeout(() => {
        tooltip.style.opacity = '0';
        setTimeout(() => {
            if (tooltip.parentNode) {
                tooltip.parentNode.removeChild(tooltip);
            }
        }, 300);
    }, 2000);
}

function updateAllQuantityDisplays(category, quantity) {
    // Update quantity display for all cards in this category
    const allCards = document.querySelectorAll(`.cs-calc-card[data-category="${category}"]`);
    allCards.forEach(card => {
        const quantityDisplay = card.querySelector('.cs-calc-quantity-display');
        if (quantityDisplay) {
            // Only update if this card is the currently selected one
            if (selectedProducts[category]?.id === card.dataset.productId) {
                quantityDisplay.textContent = quantity;
            } else {
                // Reset to 1 for non-selected cards
                quantityDisplay.textContent = '1';
            }
        }
    });
}

function updateBuildSummaryQuantity(category, quantity) {
    const summaryRow = document.querySelector(`.cs-calc-summary-row[data-category="${category}"]`);
    if (summaryRow && selectedProducts[category]) {
        const product = selectedProducts[category];
        const totalPrice = product.price * quantity;
        
        const quantityElement = summaryRow.querySelector('.cs-calc-summary-quantity');
        const priceElement = summaryRow.querySelector('.cs-calc-summary-product-price');
        
        if (quantityElement) quantityElement.textContent = `Qty: ${quantity}`;
        if (priceElement) priceElement.textContent = `₹${totalPrice.toLocaleString()}`;
    }
}

// ==================== UPDATED CORE FUNCTIONALITY ====================
function selectProduct(button) {
    const card = button.closest('.cs-calc-card');
    const category = card.dataset.category;
    const productId = card.dataset.productId;
    const price = parseInt(card.dataset.price);
    const productName = card.querySelector('.cs-calc-title').textContent;
    const imageUrl = card.dataset.imageUrl;
    const wattage = card.dataset.wattage;
    
    const isSelected = selectedProducts[category]?.id === productId;
    
    if (isSelected) {
    // Deselect product
    selectedProducts[category] = null;
    card.classList.remove('cs-calc-selected');
    button.textContent = 'SELECT';
    button.classList.remove('cs-calc-selected-btn');
    
    // Reset quantity for this category when deselecting
    if (['RAM', 'Storage (SSD)', 'Storage (HDD)', 'Case Fan', 'Monitor'].includes(category)) {
        productQuantities[category] = 1;
    }
    
    // FIX: Clear visualizer if the deslected product is currently being shown
    if (currentVisualizerCategory === category) {
        const componentImage = document.getElementById('component-image');
        const visualizer = document.getElementById('component-visualizer');
        const placeholder = visualizer.querySelector('.cs-calc-component-placeholder');
        const imageNote = document.getElementById('component-image-note');
        const nameDisplay = document.getElementById('component-name-display');
        const brandLogoContainer = document.getElementById('visual-brand-logo');
        
        // Hide the product image and show placeholder
        componentImage.style.display = 'none';
        placeholder.style.display = 'flex';
        imageNote.style.display = 'none';
        
        // Clear the name display
        nameDisplay.textContent = '';
        nameDisplay.style.display = 'none';
        brandLogoContainer.style.display = 'none';
        brandLogoContainer.innerHTML = '';
    }
    
    if (category === 'GPU') {
        // Update compatibility status
        checkCompatibility();
    }
    
    // Also update PSU recommendation when CPU is deselected (if GPU exists)
    if (category === 'CPU' && selectedProducts['GPU'] && selectedProducts['GPU'].wattage) {
        showPSURecommendation(selectedProducts['GPU'].wattage);
    }
    
    removeFromBuildSummary(category);
    updateTotalPrice();
    checkCompatibility();
    updateVisualizerIcons(); // Update icons when product is deselected
} else {
        // Deselect any other product in the same category first
        const currentlySelectedCard = document.querySelector(`.cs-calc-card.cs-calc-selected[data-category="${category}"]`);
        if (currentlySelectedCard) {
            const otherButton = currentlySelectedCard.querySelector('.cs-calc-btn');
            currentlySelectedCard.classList.remove('cs-calc-selected');
            otherButton.textContent = 'SELECT';
            otherButton.classList.remove('cs-calc-selected-btn');
            
            // Clear the previously selected product from our data
            selectedProducts[category] = null;
            
            // RESET QUANTITY FOR THIS CATEGORY WHEN SWITCHING PRODUCTS
            if (['RAM', 'Storage (SSD)', 'Storage (HDD)', 'Case Fan', 'Monitor'].includes(category)) {
                productQuantities[category] = 1;
                
                // Update quantity display for the previously selected card
                const prevQuantityDisplay = currentlySelectedCard.querySelector('.cs-calc-quantity-display');
                if (prevQuantityDisplay) {
                    prevQuantityDisplay.textContent = '1';
                }
            }
        }
        
        // Select the new product
        selectedProducts[category] = {
            id: productId,
            name: productName,
            price: price,
            socket: card.dataset.socket,
            formFactor: card.dataset.formFactor,
            ramType: card.dataset.ramType,
            wattage: wattage,
            imageUrl: imageUrl,
            coolerHeight: card.dataset.coolerHeight,
            coolerType: card.dataset.coolerType,
            radiatorSize: card.dataset.radiatorSize,
            gpuLength: card.dataset.gpuLength,
            maxCoolerHeight: card.dataset.maxCoolerHeight,
            maxGpuLength: card.dataset.maxGpuLength,
            fanSlots: card.dataset.fanSlots,
            fanSize: card.dataset.fanSize,
            fanCount: card.dataset.fanCount,
            ssdType: card.dataset.ssdType,
            ssdSlots: card.dataset.ssdSlots,
            ramSlots: card.dataset.ramSlots,
            hddSlots: card.dataset.hddSlots,
            ramCount: card.dataset.ramCount,
            preInstalledFans: card.dataset.preInstalledFans,
            maxRadiatorSize: card.dataset.maxRadiatorSize,
            connectivity: card.dataset.connectivity,
            chipset: card.dataset.chipset,
            hasIntegratedGPU: card.dataset.hasIntegratedGpu,
            brand: card.querySelector('.cs-calc-brand-logo') ? card.querySelector('.cs-calc-brand-logo img').alt : ''
        };
        
        card.classList.add('cs-calc-selected');
        button.textContent = 'DESELECT';
        button.classList.add('cs-calc-selected-btn');
        
        // UPDATE QUANTITY DISPLAY FOR NEWLY SELECTED PRODUCT
        if (['RAM', 'Storage (SSD)', 'Storage (HDD)', 'Case Fan', 'Monitor'].includes(category)) {
            const quantityDisplay = card.querySelector('.cs-calc-quantity-display');
            if (quantityDisplay) {
                quantityDisplay.textContent = productQuantities[category] || 1;
            }
        }
        
        // Update compatibility status when any component is selected/deselected
if (category === 'GPU' || category === 'CPU') {
    // Trigger compatibility check which will update the status
    checkCompatibility();
}
        
        // Auto-filter motherboards when CPU is selected
        if (category === 'CPU') {
            // Trigger motherboard reload to apply auto-filter
            const activeCategory = document.querySelector('.cs-calc-pill.cs-calc-active').dataset.category;
            if (activeCategory === 'Motherboard') {
                loadCategoryProducts('Motherboard');
            }
        }

            // Auto-filter CPUs when motherboard is selected
if (category === 'Motherboard') {
    // Get the actual motherboard product that was just selected
    const selectedMotherboard = selectedProducts[category];
    if (selectedMotherboard) {
        // Clear any CPU brand filter that might conflict
        const motherboardBrand = selectedMotherboard.brand?.toLowerCase() || '';
        const cpuFilter = selectedFilters['CPU'];
        
        if (motherboardBrand.includes('intel') && cpuFilter === 'amd') {
            selectedFilters['CPU'] = '';
            updateSelectedFilterDisplay('CPU');
        } else if (motherboardBrand.includes('amd') && cpuFilter === 'intel') {
            selectedFilters['CPU'] = '';
            updateSelectedFilterDisplay('CPU');
        }
    }
    
    // Trigger CPU reload to apply auto-filter
    const activeCategory = document.querySelector('.cs-calc-pill.cs-calc-active').dataset.category;
    if (activeCategory === 'CPU') {
        loadCategoryProducts('CPU');
    }
}
        
        addToBuildSummary(category, productName, price, imageUrl);
        updateTotalPrice();
        checkCompatibility();
        updateVisualizerIcons(); // Update icons when product is selected
        
        // Define the 14 categories that should show in visualizer
const visualizerCategories = ['CPU', 'Motherboard', 'RAM', 'Storage (SSD)', 'Storage (HDD)', 'GPU', 'Cooling', 'Case', 'Case Fan', 'Monitor', 'Keyboard', 'Mouse', 'Headset', 'Accessories'];

// Make sure name display is visible when selecting a visualizer category
const nameDisplay = document.getElementById('component-name-display');
if (nameDisplay && visualizerCategories.includes(category)) {
    nameDisplay.style.display = 'flex';
}

// If this is one of the visualizer categories, automatically show it in visualizer
if (visualizerCategories.includes(category)) {
    showComponentImage(category);
    setActiveIcon(category);
    currentVisualizerCategory = category;
}

        // Update compatibility status when selecting/deselecting products
        updateCompatibilityStatus();
    }
}

// ==================== UPDATED BUILD SUMMARY FUNCTIONS ====================
function addToBuildSummary(category, productName, price, imageUrl) {
    const summaryRows = document.querySelectorAll('.cs-calc-summary-row');
    let summaryRow = null;
    
    // Map category to display names for web UI
    const categoryDisplayNames = {
        'CPU': 'Processor',
        'Motherboard': 'Motherboard',
        'RAM': 'RAM',
        'Storage (SSD)': 'Storage (SSD)',
        'Storage (HDD)': 'Storage (HDD)',
        'GPU': 'GPU',
        'Cooling': 'Cooling',
        'PSU': 'PSU',
        'Case': 'Case',
        'Case Fan': 'Case Fan',
        'Monitor': 'Monitor',
        'Keyboard': 'Keyboard',
        'Mouse': 'Mouse',
        'Headset': 'Headset',
        'Accessories': 'Accessories'
    };
    
    const displayCategory = categoryDisplayNames[category] || category;
    
    // FIXED: Use exact matching for both "Case" and "Case Fan"
    summaryRows.forEach(row => {
        const labelElement = row.querySelector('.cs-calc-label');
        if (labelElement) {
            const labelText = labelElement.textContent.trim();
            // Find the category text before the Qty: part
            const categoryText = labelText.split('Qty:')[0].trim();
            
            // Use exact matching for ALL categories
            if (categoryText === displayCategory) {
                summaryRow = row;
            }
        }
    });
    
    if (!summaryRow) return;
    
    const quantity = productQuantities[category] || 1;
    const totalPrice = price * quantity;
    const convertedImageUrl = convertGoogleDriveUrl(imageUrl);
    
    // Get the selected product to extract brand
    const product = selectedProducts[category];
    const brand = product?.brand || '';
    
    // Format product name WITH brand prefix for build summary
    let displayName = productName;
    if (brand && !productName.toLowerCase().includes(brand.toLowerCase())) {
        // Add brand only if it's not already in the product name
        displayName = `${brand} ${productName}`;
    }
    
    // FIXED: Use 2-column structure with proper content arrangement
    summaryRow.innerHTML = `
        <div class="cs-calc-summary-content">
            <div class="cs-calc-label">
                ${displayCategory}
                <span class="cs-calc-summary-quantity">Qty: ${quantity}</span>
            </div>
            <div class="cs-calc-summary-product-name">${displayName}</div>
            <div class="cs-calc-summary-product-price">₹${totalPrice.toLocaleString()}</div>
        </div>
        <div class="cs-calc-summary-image-container">
            ${convertedImageUrl ? `<img src="${convertedImageUrl}" alt="${displayName}" class="cs-calc-summary-image" onerror="this.style.display='none'">` : ''}
        </div>
    `;
    
    summaryRow.dataset.category = category;
}

function removeFromBuildSummary(category) {
    const summaryRows = document.querySelectorAll('.cs-calc-summary-row');
    
    // Map category to display names for web UI
    const categoryDisplayNames = {
        'CPU': 'Processor',
        'Motherboard': 'Motherboard',
        'RAM': 'RAM',
        'Storage (SSD)': 'Storage (SSD)',
        'Storage (HDD)': 'Storage (HDD)',
        'GPU': 'GPU',
        'Cooling': 'Cooling',
        'PSU': 'PSU',
        'Case': 'Case',
        'Case Fan': 'Case Fan',
        'Monitor': 'Monitor',
        'Keyboard': 'Keyboard',
        'Mouse': 'Mouse',
        'Headset': 'Headset',
        'Accessories': 'Accessories'
    };
    
    const displayCategory = categoryDisplayNames[category] || category;
    
    summaryRows.forEach(row => {
        if (row.dataset.category === category) {
            // FIXED: Use the same 2-column structure for empty state
            row.innerHTML = `
                <div class="cs-calc-summary-content">
                    <div class="cs-calc-label">
                        ${displayCategory}
                        <span class="cs-calc-summary-quantity">Qty: 0</span>
                    </div>
                    <div class="cs-calc-notselected">Not Selected</div>
                    <div class="cs-calc-summary-product-price">₹0</div>
                </div>
                <div class="cs-calc-summary-image-container"></div>
            `;
            // Remove the data-category attribute when no product is selected
            delete row.dataset.category;
        }
    });

    // Also clear the visualizer name display if this was the current visualizer category
const nameDisplay = document.getElementById('component-name-display');
const brandLogoContainer = document.getElementById('visual-brand-logo');

if (currentVisualizerCategory === category) {
    // Hide the name display completely
    nameDisplay.textContent = '';
    nameDisplay.style.display = 'none';
    brandLogoContainer.style.display = 'none';
    brandLogoContainer.innerHTML = '';
}
}

function updateTotalPrice() {
    let totalProductPrice = 0;
    
    // Calculate total from selected products with quantities
    Object.entries(selectedProducts).forEach(([category, product]) => {
        if (product && product.price) {
            const quantity = productQuantities[category] || 1;
            totalProductPrice += parseInt(product.price) * quantity;
        }
    });
    
    // Calculate GST (18%)
    const gstAmount = Math.round(totalProductPrice * 0.18);
    const totalPrice = totalProductPrice + gstAmount;
    
    // Update all price displays
    const totalAmtEl = document.querySelector('.cs-calc-total-amt');
    if (totalAmtEl) totalAmtEl.textContent = `₹${totalPrice.toLocaleString()}`;
    const productTotalEl = document.querySelector('.cs-calc-product-total');
    if (productTotalEl) productTotalEl.textContent = `₹${totalProductPrice.toLocaleString()}`;
    const gstEl = document.querySelector('.cs-calc-gst');
    if (gstEl) gstEl.textContent = `₹${gstAmount.toLocaleString()}`;
    const finalEl = document.querySelector('.cs-calc-final');
    if (finalEl) finalEl.textContent = `₹${totalPrice.toLocaleString()}`;
}

// ==================== VISUALIZER ICONS FUNCTIONALITY ====================
function initializeVisualizerIcons() {
    const iconsContainer = document.getElementById('component-icons');
    
    // Use the same categories array for consistency
    const visualizerCategories = ['CPU', 'Motherboard', 'RAM', 'Storage (SSD)', 'Storage (HDD)', 'GPU', 'Cooling', 'Case', 'Case Fan', 'Monitor', 'Keyboard', 'Mouse', 'Headset', 'Accessories'];
    
    const categoryImages = {
        'CPU': 'https://pcbuildz.in/cdn/shop/files/Processor-Category-Image-by-PCBuildz.svg?v=1766823538',
        'Motherboard': 'https://pcbuildz.in/cdn/shop/files/Motherboard-Category-Image-by-PCBuildz.svg?v=1764171808',
        'RAM': 'https://pcbuildz.in/cdn/shop/files/RAM-Category-Image-by-PCBuildz.svg?v=1764256242',
        'Storage (SSD)': 'https://pcbuildz.in/cdn/shop/files/Nvme-Category-Image-by-PCBuildz.svg?v=1766823539',
        'Storage (HDD)': 'https://pcbuildz.in/cdn/shop/files/Hard-Disk-Drive-Category-Image-by-PCBuildz.svg?v=1766823539',
        'GPU': 'https://pcbuildz.in/cdn/shop/files/GPU-Category-Image-by-PCBuildz.svg?v=1764256242',
        'Cooling': 'https://pcbuildz.in/cdn/shop/files/CPU-Cooler-Category-Image-by-PCBuildz.svg?v=1764256242',
        'Case': 'https://pcbuildz.in/cdn/shop/files/PC-Case-Category-Image-by-PCBuildz.svg?v=1764256243',
        'Case Fan': 'https://pcbuildz.in/cdn/shop/files/Case-Fan-Category-Image-by-PCBuildz.svg?v=1764256243',
        'Monitor': 'https://pcbuildz.in/cdn/shop/files/Monitor-Category-Image-by-PCBuildz.svg?v=1764256242',
        'Keyboard': 'https://pcbuildz.in/cdn/shop/files/Keyboard-Category-Image-by-PCBuildz.svg?v=1764256242',
        'Mouse': 'https://pcbuildz.in/cdn/shop/files/Mouse-Category-Image-by-PCBuildz.svg?v=1764256242',
        'Headset': 'https://pcbuildz.in/cdn/shop/files/Headset-Category-Image-by-PCBuildz.svg?v=1764256242',
        'Accessories': 'https://pcbuildz.in/cdn/shop/files/PC-Accessories-Category-Image-by-PCBuildz.svg?v=1764256243'
    };
    
    visualizerCategories.forEach(category => {
        const icon = document.createElement('div');
        icon.className = 'cs-calc-visual-icon';
        icon.dataset.category = category;
        
        // Add specific class for Case icon
        if (category === 'Case') {
            icon.classList.add('cs-calc-case-icon');
        }
        
        icon.innerHTML = `
            <img src="${categoryImages[category]}" alt="${category}" class="cs-calc-visual-icon-img">
            <div class="cs-calc-icon-tooltip">${category}</div>
        `;
        
        icon.addEventListener('click', function() {
    if (!this.classList.contains('disabled')) {
        const category = this.dataset.category;
        
        // Make sure name display is visible
        const nameDisplay = document.getElementById('component-name-display');
        if (nameDisplay) {
            nameDisplay.style.display = 'flex'; // Use flex to show it
        }
        
        // Only apply scale effect on mobile (880px and below)
        if (window.innerWidth <= 880) {
            // Enlarge the icon immediately
            this.style.transform = 'scale(1.5)';
            
            // Set timeout to return to normal size after 1 second
            setTimeout(() => {
                this.style.transform = 'scale(1)';
            }, 1000);
        }
        
        showComponentImage(category);
        setActiveIcon(category);
        currentVisualizerCategory = category;
    }
});
        
        iconsContainer.appendChild(icon);
    });
    
    updateVisualizerIcons();
}

function updateVisualizerIcons() {
    const icons = document.querySelectorAll('.cs-calc-visual-icon');
    const visualizerCategories = ['CPU', 'Motherboard', 'RAM', 'Storage (SSD)', 'Storage (HDD)', 'GPU', 'Cooling', 'Case', 'Case Fan', 'Monitor', 'Keyboard', 'Mouse', 'Headset', 'Accessories'];
    
    icons.forEach(icon => {
        const category = icon.dataset.category;
        if (selectedProducts[category] && visualizerCategories.includes(category)) {
            icon.classList.remove('disabled');
        } else {
            icon.classList.add('disabled');
        }
    });
}

function setActiveIcon(category) {
    const icons = document.querySelectorAll('.cs-calc-visual-icon');
    icons.forEach(icon => {
        icon.classList.remove('active');
        if (icon.dataset.category === category) {
            icon.classList.add('active');
        }
    });
}

function showComponentImage(category) {
    const componentImage = document.getElementById('component-image');
    const visualizer = document.getElementById('component-visualizer');
    const placeholder = visualizer.querySelector('.cs-calc-component-placeholder');
    const imageNote = document.getElementById('component-image-note');
    const nameDisplay = document.getElementById('component-name-display');
    const brandLogoContainer = document.getElementById('visual-brand-logo');
    
    const product = selectedProducts[category];
    
    // UPDATE THE NAME DISPLAY (SHOW ONLY PRODUCT NAME, NO BRAND PREFIX)
if (product && product.name) {
    nameDisplay.textContent = product.name; // Just show product name
    
    // SHOW BRAND LOGO IN VISUALIZER
    if (product.brand && BRAND_LOGOS[product.brand]) {
        const brandInfo = BRAND_LOGOS[product.brand];
        brandLogoContainer.innerHTML = `
            <img src="${brandInfo.url}" 
                 alt="${product.brand}" 
                 style="width: auto; height: ${brandInfo.height};">
        `;
        brandLogoContainer.style.display = 'block';
    } else {
        brandLogoContainer.style.display = 'none';
        brandLogoContainer.innerHTML = '';
    }
} else {
    // If no product selected, hide the name display completely
    nameDisplay.textContent = '';
    nameDisplay.style.display = 'none';
    brandLogoContainer.style.display = 'none';
    brandLogoContainer.innerHTML = '';
}
    
    if (product && product.imageUrl) {
        let directImageUrl = convertGoogleDriveUrl(product.imageUrl);
        
        // Create a new image to test loading
        const testImage = new Image();
        testImage.onload = function() {
            componentImage.src = directImageUrl;
            componentImage.style.display = 'block';
            placeholder.style.display = 'none';
            // Only show the note for Case images
            if (category === 'Case') {
                imageNote.style.display = 'block';
            } else {
                imageNote.style.display = 'none';
            }
        };
        testImage.onerror = function() {
            // Alternative method: Use the file ID directly
            let fileId = null;
            if (directImageUrl.includes('/d/')) {
                const fileIdMatch = directImageUrl.match(/\/d\/([^\/]+)/);
                if (fileIdMatch && fileIdMatch[1]) fileId = fileIdMatch[1];
            } else if (directImageUrl.includes('open?id=')) {
                const fileIdMatch = directImageUrl.split('id=')[1];
                if (fileIdMatch) fileId = fileIdMatch;
            }

            if (fileId) {
                const alternativeUrl = `https://drive.google.com/thumbnail?id=${fileId}&sz=w500`;
                componentImage.src = alternativeUrl;
                componentImage.style.display = 'block';
                placeholder.style.display = 'none';
                // Only show the note for Case images
                if (category === 'Case') {
                    imageNote.style.display = 'block';
                } else {
                    imageNote.style.display = 'none';
                }
            } else {
                componentImage.style.display = 'none';
                placeholder.style.display = 'flex';
                imageNote.style.display = 'none';
            }
        };
        testImage.src = directImageUrl;
        
    } else {
        componentImage.style.display = 'none';
        placeholder.style.display = 'flex';
        imageNote.style.display = 'none';
    }
}

// ==================== COMPATIBILITY STATUS FUNCTIONS ====================
function updateCompatibilityStatus(hasWarnings) {
    const statusContainer = document.getElementById('compatibility-status');
    const statusMessage = document.getElementById('status-message');
    
    // Count selected products
    const selectedCount = Object.values(selectedProducts).filter(product => product !== null).length;
    
    if (hasWarnings === undefined) {
        // Check current warnings
        const warningsContainer = document.getElementById('compatibility-warnings');
        hasWarnings = warningsContainer && 
                      warningsContainer.style.display === 'block' && 
                      warningsContainer.classList.contains('has-warnings');
    }
    
    if (hasWarnings) {
        // ALWAYS show "Fix compatibility issues" when there are warnings (regardless of product count)
        statusMessage.innerHTML = `<span style="font-size: 18px;">⚠️</span> <span>Fix compatibility issues</span>`;
        statusContainer.classList.add('has-issues');
        statusContainer.style.display = 'block';
        
        // Make it clickable
        statusContainer.onclick = function() {
            scrollToCompatibilityWarnings();
        };
        statusContainer.style.cursor = 'pointer';
    } else if (selectedCount >= 3) {
        // Show "All selected components are compatible" only when no warnings AND at least 3 products
        statusMessage.innerHTML = `<span style="font-size: 20px;">✅</span> <span>All selected components are compatible</span>`;
        statusContainer.classList.remove('has-issues');
        statusContainer.style.display = 'block';
        
        // Remove click event
        statusContainer.onclick = null;
        statusContainer.style.cursor = 'default';
    } else {
        // Hide status if no warnings AND less than 3 products
        statusContainer.style.display = 'none';
    }
}

function hideCompatibilityStatus() {
    const statusContainer = document.getElementById('compatibility-status');
    statusContainer.style.display = 'none';
}

// ==================== SIMPLIFIED RADIATOR COMPATIBILITY ====================
function checkRadiatorCompatibility(selectedCooling, selectedCase, warnings) {
    if (selectedCooling && selectedCase && selectedCooling.coolerType === 'Liquid') {
        const radiatorSize = parseInt(selectedCooling.radiatorSize) || 0;
        const caseMaxRadiator = parseInt(selectedCase.maxRadiatorSize) || 0;

        // Simple check: cooler radiator size vs case max radiator size
        if (caseMaxRadiator > 0 && radiatorSize > caseMaxRadiator) {
            warnings.push(`❌ <strong>Radiator Too Large:</strong> ${radiatorSize}mm radiator exceeds case maximum support (${caseMaxRadiator}mm)`);
            return true; // has issue
        }

        // Success message
        if (radiatorSize > 0 && caseMaxRadiator > 0 && radiatorSize <= caseMaxRadiator) {
            warnings.push(`✅ <strong>Radiator Compatible:</strong> ${radiatorSize}mm radiator fits case (max ${caseMaxRadiator}mm)`);
        }

        return false; // no issue
    }
    return false;
}

// ==================== ENHANCED COMPATIBILITY SYSTEM ====================
function checkCompatibility() {
    const warnings = [];
    
    const selectedCPU = selectedProducts['CPU'];
    const selectedMB = selectedProducts['Motherboard'];
    const selectedRAM = selectedProducts['RAM'];
    const selectedCase = selectedProducts['Case'];
    const selectedPSU = selectedProducts['PSU'];
    const selectedGPU = selectedProducts['GPU'];
    const selectedCooling = selectedProducts['Cooling'];
    const selectedCaseFan = selectedProducts['Case Fan'];
    const selectedSSD = selectedProducts['Storage (SSD)'];
    const selectedHDD = selectedProducts['Storage (HDD)'];

    const selectedCount = [selectedCPU, selectedMB, selectedRAM, selectedCase, selectedPSU, selectedGPU, selectedSSD, selectedHDD, selectedCooling].filter(Boolean).length;
    
    // Track if we have any actual errors or warnings
    let hasErrorOrWarning = false;

    // NEW: CPU Integrated GPU Check
    if (selectedCPU && selectedCPU.hasIntegratedGPU && selectedCPU.hasIntegratedGPU.toLowerCase() === 'no' && !selectedGPU) {
        warnings.push(`❌ <strong>GPU Required:</strong> Selected CPU has no integrated GPU. Please select a Graphics Card.`);
        hasErrorOrWarning = true;
    }

    // 1. CPU-Motherboard socket check
    if (selectedCPU && selectedMB) {
        const cpuSocket = selectedCPU.socket;
        const mbSocket = selectedMB.socket;
        
        if (cpuSocket && mbSocket && cpuSocket !== mbSocket) {
            warnings.push(`❌ <strong>CPU-Motherboard Mismatch:</strong> ${cpuSocket} CPU doesn't work with ${mbSocket} motherboard`);
            hasErrorOrWarning = true;
        }
    }
    
    // 2. Motherboard-RAM compatibility
    if (selectedMB && selectedRAM) {
        const mbRamType = selectedMB.ramType;
        const ramType = selectedRAM.ramType;
        
        if (mbRamType && ramType && mbRamType !== ramType) {
            warnings.push(`❌ <strong>RAM Compatibility:</strong> Motherboard supports ${mbRamType} but you selected ${ramType} RAM`);
            hasErrorOrWarning = true;
        }
        
        // RAM Slots compatibility check WITH QUANTITY AND STICK COUNT
        const mbRamSlots = parseInt(selectedMB.ramSlots) || 0;
        const ramQuantity = productQuantities['RAM'] || 1;
        const ramCount = parseInt(selectedRAM.ramCount) || 1;
        const totalRamSticks = ramQuantity * ramCount;
        
        if (mbRamSlots > 0 && totalRamSticks > mbRamSlots) {
            warnings.push(`❌ <strong>RAM Slots Exceeded:</strong> Motherboard has only ${mbRamSlots} RAM slots but you selected ${totalRamSticks} RAM sticks`);
            hasErrorOrWarning = true;
        } else if (mbRamSlots > 0 && totalRamSticks <= mbRamSlots) {
            const slotText = pluralize(totalRamSticks, 'RAM slot', 'RAM slots');
            warnings.push(`✅ <strong>RAM Slots:</strong> ${totalRamSticks} of ${mbRamSlots} ${slotText} used`);
        }
    }
    
    // 3. Case-Motherboard form factor
    if (selectedCase && selectedMB) {
        const caseFormFactor = selectedCase.formFactor;
        const mbFormFactor = selectedMB.formFactor;
        
        if (caseFormFactor && mbFormFactor && !isFormFactorCompatible(caseFormFactor, mbFormFactor)) {
            warnings.push(`❌ <strong>Case Compatibility:</strong> ${mbFormFactor} motherboard will not fit in ${caseFormFactor} case`);
            hasErrorOrWarning = true;
        }
    }
    
    // 4. PSU and Cooler compatibility
    if (selectedPSU && selectedCooling) {
        const psuWattage = parseInt(selectedPSU.wattage) || 0;
        const coolerType = selectedCooling.coolerType;
        
        if (coolerType === 'Liquid' && psuWattage < 650) {
            warnings.push(`⚠️ <strong>PSU & Liquid Cooling:</strong> Liquid cooling systems may require more stable power delivery - consider a higher wattage PSU`);
            hasErrorOrWarning = true;
        }
    }
    
    // 5. GPU and PSU wattage compatibility
    if (selectedGPU && selectedPSU) {
        const gpuWattage = parseInt(selectedGPU.wattage) || 0;
        const psuWattage = parseInt(selectedPSU.wattage) || 0;
        
        if (gpuWattage > 0 && psuWattage > 0) {
            if (psuWattage < gpuWattage) {
                warnings.push(`❌ <strong>PSU Wattage Insufficient:</strong> Your ${psuWattage}W PSU will not provide enough power for your PC. Recommended PSU: ${gpuWattage}W`);
                hasErrorOrWarning = true;
            } else if (psuWattage >= gpuWattage) {
                warnings.push(`✅ <strong>PSU Wattage:</strong> ${psuWattage}W PSU is sufficient for your selected components`);
            }
        }
    } else if (selectedGPU && selectedGPU.wattage && !selectedPSU) {
        const gpuWattage = parseInt(selectedGPU.wattage) || 0;
        if (gpuWattage > 0) {
            warnings.push(`✅ <strong>PSU Recommendation:</strong> For your selected components, consider a ${gpuWattage}W PSU`);
        }
    }
    
    // 6. Cooler and Case compatibility
    if (selectedCooling && selectedCase) {
        // SIMPLIFIED RADIATOR COMPATIBILITY CHECK
        const radiatorIssue = checkRadiatorCompatibility(selectedCooling, selectedCase, warnings);
        if (radiatorIssue) hasErrorOrWarning = true;
        
        // Cooler height check
        const coolerHeight = parseInt(selectedCooling.coolerHeight) || 0;
        const caseMaxCoolerHeight = parseInt(selectedCase.maxCoolerHeight) || 0;
        
        if (coolerHeight > caseMaxCoolerHeight) {
            warnings.push(`❌ <strong>Cooler & Case Fit:</strong> CPU cooler (${coolerHeight}mm) may not fit in the case (max ${caseMaxCoolerHeight}mm)`);
            hasErrorOrWarning = true;
        }
        
        // Liquid cooler fan calculations
        if (selectedCooling.coolerType === 'Liquid') {
            const radiatorSize = parseInt(selectedCooling.radiatorSize) || 0;
            const caseFanSlots = parseInt(selectedCase.fanSlots) || 0;
            const preInstalledFans = parseInt(selectedCase.preInstalledFans) || 0;
            const caseFanQuantity = productQuantities['Case Fan'] || 0;
            
            // Calculate radiator fan slots
            if (radiatorSize > 0 && caseFanSlots > 0) {
                const radiatorFanSlots = Math.ceil(radiatorSize / 120);
                
                // Calculate total fans: pre-installed + case fans + radiator fans
                const totalFansUsed = preInstalledFans + caseFanQuantity + radiatorFanSlots;
                const availableFanSlots = caseFanSlots - totalFansUsed;
                
                // Only show "Fan Slot Availability" when NO case fans are selected
                if (caseFanQuantity === 0) {
                    const slotText = pluralize(availableFanSlots, 'fan slot', 'fan slots');
                    warnings.push(`✅ <strong>Fan Slot Availability:</strong> After radiator installation, ${availableFanSlots} ${slotText} available for case fans`);
                }
            }
        }
    }
    
    // 7. GPU and Case compatibility - GPU length check
    if (selectedGPU && selectedCase) {
        const gpuLength = parseInt(selectedGPU.gpuLength) || 0;
        const caseMaxGpuLength = parseInt(selectedCase.maxGpuLength) || 0;
        
        if (gpuLength > 0 && caseMaxGpuLength > 0 && gpuLength > caseMaxGpuLength) {
            warnings.push(`❌ <strong>GPU & Case Fit:</strong> GPU (${gpuLength}mm) may not fit in the case (max ${caseMaxGpuLength}mm)`);
            hasErrorOrWarning = true;
        } else if (gpuLength > 0 && caseMaxGpuLength > 0 && gpuLength <= caseMaxGpuLength) {
            warnings.push(`✅ <strong>GPU Fit:</strong> GPU (${gpuLength}mm) fits within case limit (${caseMaxGpuLength}mm)`);
        }
    }
    
    // 8. Case Fan and Case compatibility WITH QUANTITY CHECK AND PRE-INSTALLED FANS
if (selectedCaseFan && selectedCase) {
    const fanSize = parseInt(selectedCaseFan.fanSize) || 0;
    const caseFanSlots = parseInt(selectedCase.fanSlots) || 0;
    const caseFanPackQuantity = productQuantities['Case Fan'] || 1;
    const fansPerPack = parseInt(selectedCaseFan.fanCount) || 1; // Get fans per pack
    const caseFanQuantity = caseFanPackQuantity * fansPerPack; // Total fans = packs × fans per pack
    const preInstalledFans = parseInt(selectedCase.preInstalledFans) || 0;
        
        // Check if there's a liquid cooler with radiator
        let radiatorFanSlots = 0;
        if (selectedCooling && selectedCooling.coolerType === 'Liquid') {
            const radiatorSize = parseInt(selectedCooling.radiatorSize) || 0;
            radiatorFanSlots = Math.ceil(radiatorSize / 120);
        }
        
        // Calculate total fans (pre-installed + case fans + radiator fans)
        const totalFans = preInstalledFans + caseFanQuantity + radiatorFanSlots;
        
        // Always show pre-installed fans and radiator fans messages
        if (preInstalledFans > 0) {
            const fanText = pluralize(preInstalledFans, 'pre-installed fan', 'pre-installed fans');
            warnings.push(`✅ <strong>Pre-installed Fans:</strong> Case comes with ${preInstalledFans} ${fanText}`);
        }
        
        if (radiatorFanSlots > 0) {
            const fanText = pluralize(radiatorFanSlots, 'fan slot', 'fan slots');
            warnings.push(`✅ <strong>Radiator Fans:</strong> Liquid cooler uses ${radiatorFanSlots} ${fanText}`);
        }
        
                // Check if total fans exceed case fan slots
        if (totalFans > caseFanSlots) {
            const fanText = pluralize(totalFans, 'fan', 'fans');
            const slotText = pluralize(caseFanSlots, 'fan slot', 'fan slots');
            warnings.push(`❌ <strong>Fan Slots Exceeded:</strong> Case has only ${caseFanSlots} ${slotText} but you have selected ${totalFans} ${fanText} total (${preInstalledFans} pre-installed + ${caseFanQuantity} case fans${radiatorFanSlots > 0 ? ` + ${radiatorFanSlots} radiator fans` : ''})`);
            hasErrorOrWarning = true;
        } else {
            const availableForExtraFans = caseFanSlots - totalFans;
            if (availableForExtraFans >= 0) {
                const fanText = pluralize(totalFans, 'fan', 'fans');
                const slotText = pluralize(caseFanSlots, 'fan slot', 'fan slots');
                warnings.push(`✅ <strong>Total Fan Slot Usage:</strong> ${totalFans} of ${caseFanSlots} ${slotText} used (${preInstalledFans} pre-installed + ${caseFanQuantity} case fans${radiatorFanSlots > 0 ? ` + ${radiatorFanSlots} radiator fans` : ''})`);
                // Only show "Extra Fan Capacity" when case fans ARE selected
                if (availableForExtraFans > 0 && caseFanPackQuantity > 0) {
                    const extraText = pluralize(availableForExtraFans, 'fan slot', 'fan slots');
                    warnings.push(`✅ <strong>Extra Fan Capacity:</strong> ${availableForExtraFans} ${extraText} available for additional case fans`);
                }
            }
        }
        
        // Check if fan size is compatible with case
        const caseSupportedSizes = getCaseSupportedFanSizes(selectedCase);
        if (fanSize > 0 && caseSupportedSizes.length > 0 && !caseSupportedSizes.includes(fanSize)) {
            warnings.push(`❌ <strong>Fan Size Compatibility:</strong> Case fan (${fanSize}mm) not compatible with case supported sizes (${caseSupportedSizes.join(', ')}mm)`);
            hasErrorOrWarning = true;
        }
    } else if (selectedCase && !selectedCaseFan) {
        // Show pre-installed fan info even when no extra fans are selected
        const preInstalledFans = parseInt(selectedCase.preInstalledFans) || 0;
        const caseFanSlots = parseInt(selectedCase.fanSlots) || 0;
        
        // Check if there's a liquid cooler with radiator
        let radiatorFanSlots = 0;
        if (selectedCooling && selectedCooling.coolerType === 'Liquid') {
            const radiatorSize = parseInt(selectedCooling.radiatorSize) || 0;
            radiatorFanSlots = Math.ceil(radiatorSize / 120);
        }
        
        const totalFans = preInstalledFans + radiatorFanSlots;
        const availableForExtraFans = caseFanSlots - totalFans;
        
        if (preInstalledFans > 0) {
            const fanText = pluralize(preInstalledFans, 'pre-installed fan', 'pre-installed fans');
            warnings.push(`✅ <strong>Pre-installed Fans:</strong> Case comes with ${preInstalledFans} ${fanText}`);
        }
        
        if (radiatorFanSlots > 0) {
            const fanText = pluralize(radiatorFanSlots, 'fan slot', 'fan slots');
            warnings.push(`✅ <strong>Radiator Fans:</strong> Liquid cooler uses ${radiatorFanSlots} ${fanText}`);
        }
        
        if (totalFans > 0) {
            const fanText = pluralize(totalFans, 'fan', 'fans');
            const slotText = pluralize(caseFanSlots, 'fan slot', 'fan slots');
            warnings.push(`✅ <strong>Total Fan Slot Usage:</strong> ${totalFans} of ${caseFanSlots} ${slotText} used${radiatorFanSlots > 0 ? ` (${preInstalledFans} pre-installed + ${radiatorFanSlots} radiator fans)` : ''}`);
        }
        
        // Don't show "Extra Fan Capacity" when no case fans are selected
    }
    
    // 9. SSD and Motherboard compatibility WITH QUANTITY CHECK
    if (selectedSSD && selectedMB) {
        const ssdType = selectedSSD.ssdType;
        const mbSsdSlots = parseInt(selectedMB.ssdSlots) || 0;
        const ssdQuantity = productQuantities['Storage (SSD)'] || 1;
        
        // Check if SSD quantity exceeds motherboard SSD slots
        if (ssdQuantity > mbSsdSlots) {
            const slotText = pluralize(mbSsdSlots, 'SSD slot', 'SSD slots');
            warnings.push(`❌ <strong>SSD Slots Exceeded:</strong> Motherboard has only ${mbSsdSlots} ${slotText} but you selected ${ssdQuantity} SSDs`);
            hasErrorOrWarning = true;
        } else if (mbSsdSlots > 0 && ssdQuantity <= mbSsdSlots) {
            const slotText = pluralize(mbSsdSlots, 'SSD slot', 'SSD slots');
            warnings.push(`✅ <strong>SSD Slots:</strong> ${ssdQuantity} of ${mbSsdSlots} ${slotText} used`);
        }
        
        // NVMe specific check
        if (ssdType === 'NVMe' && mbSsdSlots < 1) {
            warnings.push(`❌ <strong>NVMe Support:</strong> Motherboard may not have M.2 slots for your NVMe SSD`);
            hasErrorOrWarning = true;
        }
    }

    // 10. HDD and Case compatibility WITH QUANTITY CHECK
    if (selectedHDD && selectedCase) {
        const hddQuantity = productQuantities['Storage (HDD)'] || 1;
        const caseHddSlots = parseInt(selectedCase.hddSlots) || 0;
        
        if (caseHddSlots > 0 && hddQuantity > caseHddSlots) {
            const bayText = pluralize(caseHddSlots, 'HDD bay', 'HDD bays');
            warnings.push(`❌ <strong>HDD Bays Exceeded:</strong> Case has only ${caseHddSlots} ${bayText} but you selected ${hddQuantity} HDDs`);
            hasErrorOrWarning = true;
        } else if (caseHddSlots > 0 && hddQuantity <= caseHddSlots) {
            const bayText = pluralize(caseHddSlots, 'HDD bay', 'HDD bays');
            warnings.push(`✅ <strong>HDD Bays:</strong> ${hddQuantity} of ${caseHddSlots} ${bayText} used`);
        }
    }

    // Get the buttons and overlay
    const pdfBtn = document.querySelector('.cs-calc-pdf-btn');
    const emailBtn = document.querySelector('.cs-calc-email-btn');
    const exportOverlay = document.getElementById('export-overlay');

    // Show/hide export overlay and disable/enable buttons based on compatibility issues
    if (hasErrorOrWarning) {
        // Compatibility issues detected - show overlay and disable buttons
        if (exportOverlay) {
            exportOverlay.style.display = 'flex';
            exportOverlay.innerHTML = `
                <div class="cs-calc-export-overlay-icon">⚠️</div>
                <div class="cs-calc-export-overlay-text" style="color:black;">
                    <strong>Compatibility Issues Detected!</strong><br>
                    Please resolve all compatibility warnings before downloading or e-mailing quotations.
                </div>
            `;
        }
        
        // Disable buttons
        if (pdfBtn) {
            pdfBtn.disabled = true;
            pdfBtn.style.opacity = '0.6';
            pdfBtn.style.cursor = 'not-allowed';
            pdfBtn.title = 'Please resolve compatibility issues first';
        }
        
        if (emailBtn) {
            emailBtn.disabled = true;
            emailBtn.style.opacity = '0.6';
            emailBtn.style.cursor = 'not-allowed';
            emailBtn.title = 'Please resolve compatibility issues first';
        }
        
    } else {
        // No compatibility issues - hide overlay and enable buttons (only for India users)
        if (exportOverlay && csCalcIsIndiaUser) {
            exportOverlay.style.display = 'none';
        }
        
        // Enable buttons only for India users
        if (csCalcIsIndiaUser) {
            if (pdfBtn) {
                pdfBtn.disabled = false;
                pdfBtn.style.opacity = '1';
                pdfBtn.style.cursor = 'pointer';
                pdfBtn.title = 'Generate PDF quotation';
            }
            
            if (emailBtn) {
                emailBtn.disabled = false;
                emailBtn.style.opacity = '1';
                emailBtn.style.cursor = 'pointer';
                emailBtn.title = 'Send quotation via email';
            }
        }
    }

    const warningsContainer = document.getElementById('compatibility-warnings');
    const warningList = document.getElementById('warning-list');
    
    if (!warningsContainer) {
        console.error('Compatibility warnings container not found!');
        return;
    }

    // Get the warning title - try different selectors
    let warningTitle = warningsContainer.querySelector('h3');
    if (!warningTitle) {
        warningTitle = warningsContainer.querySelector('.cs-calc-warning-title');
    }
    if (!warningTitle) {
        // If still not found, look for any h3 element
        const allH3 = warningsContainer.getElementsByTagName('h3');
        if (allH3.length > 0) {
            warningTitle = allH3[0];
        }
    }

    // ALWAYS hide the warning title first, then show it only if needed
    if (warningTitle) {
        warningTitle.style.display = 'none';
    }
    
    if (warnings.length > 0) {
        // If there are only success messages, add the "All compatible" message
        if (!hasErrorOrWarning) {
            warnings.push(`✅ <strong style="color: #065f46;">All selected components are compatible!</strong>`);
        }
        
        warningList.innerHTML = warnings.map(warning => 
            `<li class="cs-calc-warning-item">${warning}</li>`
        ).join('');
        warningsContainer.style.display = 'block';
        
        // NEW: Apply red styling when there are actual warnings/errors
        if (hasErrorOrWarning) {
            warningsContainer.classList.add('has-warnings');
            warningsContainer.classList.remove('cs-calc-compatible');
            // Warning title already shown from above
            if (warningTitle) {
                warningTitle.style.display = 'block';
            }
        } else {
            // Only success messages - show green background
            warningsContainer.classList.remove('has-warnings');
            warningsContainer.classList.add('cs-calc-compatible');
        }
    } else if (selectedCount >= 4) {
        // No warnings but components selected - show all compatible message
        warningList.innerHTML = '<li class="cs-calc-warning-item">✅ <strong>All selected components are compatible!</strong></li>';
        warningsContainer.style.display = 'block';
        warningsContainer.classList.add('cs-calc-compatible');
        warningsContainer.classList.remove('has-warnings');
        // Warning title already hidden from above
    } else {
        warningsContainer.style.display = 'none';
        warningsContainer.classList.remove('has-warnings', 'cs-calc-compatible');
    }

    // NUCLEAR OPTION - Force hide any warning titles when only success messages
    if (!hasErrorOrWarning && warningsContainer.style.display === 'block') {
        const allTitles = warningsContainer.querySelectorAll('h3, .cs-calc-warning-title');
        allTitles.forEach(title => {
            title.style.display = 'none';
        });
    }

    // Update compatibility button visibility
    updateCompatibilityButtonVisibility(hasErrorOrWarning);
    // Update compatibility status display
    updateCompatibilityStatus(hasErrorOrWarning);
}

function getCaseSupportedFanSizes(selectedCase) {
    // This is a simplified function - in a real implementation, you'd get this from case data
    const supportedSizes = [];
    
    if (selectedCase.fanSlots) {
        // Most cases support 120mm and 140mm fans
        supportedSizes.push(120, 140);
    }
    
    return supportedSizes;
}

function isFormFactorCompatible(caseSize, mbSize) {
    const compatibility = {
        'ATX': ['ATX', 'Micro-ATX', 'Mini-ITX'],
        'Micro-ATX': ['Micro-ATX', 'Mini-ITX'],
        'Mini-ITX': ['Mini-ITX'],
        'E-ATX': ['E-ATX', 'ATX', 'Micro-ATX', 'Mini-ITX']
    };
    return compatibility[caseSize]?.includes(mbSize) || false;
}

// ==================== EMAIL FUNCTIONALITY ====================
function buildSlimEmailData() {
  const slimData = {};

  Object.entries(selectedProducts).forEach(([category, product]) => {
    if (!product) return;

    slimData[category] = {
      name: product.name || '',
      brand: product.brand || '',
      price: Number(product.price) || 0,
      imageUrl: product.imageUrl || product.image || '',
      wattage: product.wattage || null
    };
  });

  return slimData;
}

async function sendQuotationEmail() {
    // Add the same check here
    const selectedComponents = Object.values(selectedProducts).filter(product => product !== null).length;
    if (selectedComponents < 4) {
        showEmailMessage('Please select at least 4 components before sending quotation', 'error');
        return;
    }

    // Double-check: ensure no compatibility issues and user is from India
    if (!csCalcIsIndiaUser) {
        showEmailMessage('Quotation emailing is available to Indian users only.', 'error');
        return;
    }
    
    // Additional protection: check if buttons are disabled
    const emailBtn = document.querySelector('.cs-calc-email-btn');
    if (emailBtn && emailBtn.disabled) {
        showEmailMessage('Please resolve compatibility issues first', 'error');
        return;
    }

    const customerName = document.getElementById('customer-name').value.trim();
    const customerEmail = document.getElementById('customer-email').value.trim();
    const emailButton = document.querySelector('.cs-calc-email-btn');
    const messageDiv = document.getElementById('email-message');

    // Frontend validation (match backend rules)
    if (!customerName || customerName.length < 2 || customerName.length > 30) {
    showEmailMessage('Please enter a valid name (2-30 characters)', 'error');
    return;
    }

    if (!customerEmail || !isValidEmail(customerEmail)) {
        showEmailMessage('Please enter a valid email address', 'error');
        return;
    }

    // Frontend rate limiting - minimum 10 seconds between submissions
    const currentTime = Date.now();
    if (currentTime - lastSubmissionTime < 10000) {
        showEmailMessage('Please wait 10 seconds before sending another request', 'error');
        return;
    }

    // Show loading state ON THE BUTTON
    //emailButton.innerHTML = '<div class="cs-calc-button-loading">Sending...</div>';
    //emailButton.disabled = true;
    //messageDiv.style.display = 'none'; // Hide any previous messages
    
    lastSubmissionTime = currentTime;

    // Prepare payload ONCE (after all validations)
const payload = {
    customerName: customerName,
    customerEmail: customerEmail,
    buildData: buildSlimEmailData(),
    productQuantities: productQuantities,
    totalPrice: calculateTotalPrice(),
    timestamp: new Date().toISOString()
};

// Decide how to send email
if (isMobileDevice()) {
    showEmailLayoutPopup(function(layoutChoice) {
        // layoutChoice = "desktop" or "mobile"
        payload.emailLayout = layoutChoice;
        actuallySendQuotationEmail(payload);
    });
} else {
    payload.emailLayout = "desktop";
    actuallySendQuotationEmail(payload);
}
}

// ADD THIS JSONP FUNCTION
function sendJsonpRequest(data) {
    return new Promise((resolve, reject) => {
        const callbackName = 'jsonp_callback_' + Math.round(100000 * Math.random());
        const script = document.createElement('script');
        
        // Build the URL with parameters for GET request
        const params = new URLSearchParams();
        params.append('callback', callbackName);
        params.append('data', JSON.stringify(data));
        
        script.src = `${GOOGLE_SCRIPT_URL}?${params.toString()}`;
        
        // Set timeout (30 seconds)
        const timeoutId = setTimeout(() => {
            cleanup();
            reject(new Error('Request timeout - please try again'));
        }, 30000);
        
        // Define cleanup function
        function cleanup() {
            clearTimeout(timeoutId);
            delete window[callbackName];
            if (script.parentNode) {
                script.parentNode.removeChild(script);
            }
        }
        
        // Define the callback function that Google Apps Script will call
        window[callbackName] = function(response) {
            cleanup();
            resolve(response);
        };
        
        script.onerror = function() {
            cleanup();
            reject(new Error('Network error - failed to connect to server'));
        };
        
        document.body.appendChild(script);
    });
}

function showEmailMessage(message, type) {
    const messageDiv = document.getElementById('email-message');
    messageDiv.textContent = message;
    messageDiv.className = `cs-calc-message ${type}`;
    messageDiv.style.display = 'block';
    
    // Add loading animation for loading state
    if (type === 'loading') {
        messageDiv.innerHTML = `
            <div style="display: flex; align-items: center; justify-content: center; gap: 10px;">
                <div style="width: 20px; height: 20px; border: 2px solid #f3f3f3; border-top: 2px solid #10b981; border-radius: 50%; animation: spin 1s linear infinite;"></div>
                <span>${message}</span>
            </div>
        `;
    }
    
    // ADD THIS: Auto-hide after 3 seconds for error/success messages (except loading)
    if (type !== 'loading') {
        setTimeout(() => {
            messageDiv.style.display = 'none';
        }, 10000);
    }
}

function isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
}

// ==================== DATE TIME FORMATTING ====================
function getFormattedDateTime() {
    const now = new Date();
    
    // Format date as DD/MM/YYYY
    const day = String(now.getDate()).padStart(2, '0');
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const year = now.getFullYear();
    
    // Format time in 12-hour format
    let hours = now.getHours();
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    const formattedHours = String(hours).padStart(2, '0');
    
    return `${day}/${month}/${year} - ${formattedHours}:${minutes} ${ampm}`;
}

// ==================== CALCULATION HELPERS ====================
function calculateTotalProductPrice() {
    let total = 0;
    Object.entries(selectedProducts).forEach(([category, product]) => {
        if (product && product.price) {
            const qty = productQuantities[category] || 1;
            total += product.price * qty;
        }
    });
    return total;
}

function calculateGST() {
    return Math.round(calculateTotalProductPrice() * 0.18);
}

function calculateTotalPrice() {
    return calculateTotalProductPrice() + calculateGST();
}

// ==================== EMAIL LAYOUT SELECTION POPUP ====================

function showEmailLayoutPopup(onSelect) {
  // Create overlay
  const overlay = document.createElement("div");
  overlay.id = "cs-email-layout-overlay";

  // Create popup box
  const popup = document.createElement("div");
  popup.id = "cs-email-layout-popup";

  popup.innerHTML = `
    <div class="cs-email-popup-header">
      <span>Will you open the email on Desktop or Mobile?</span>
      <button class="cs-email-popup-close">&times;</button>
    </div>

    <div class="cs-email-popup-body">
      <button class="cs-email-popup-btn desktop">
        Send Desktop Email >>>
        <small>Best if you will open this email on a laptop or desktop computer</small>
      </button>

      <button class="cs-email-popup-btn mobile">
        Send Mobile Email >>>
        <small>Optimized for viewing on mobile phones</small>
      </button>
    </div>
  `;

  overlay.appendChild(popup);
  document.body.appendChild(overlay);

  // Close popup (cancel)
  overlay.querySelector(".cs-email-popup-close").onclick = () => {
    document.body.removeChild(overlay);
  };

  overlay.onclick = (e) => {
    if (e.target === overlay) {
      document.body.removeChild(overlay);
    }
  };

  // Button actions
  popup.querySelector(".desktop").onclick = () => {
    document.body.removeChild(overlay);
    onSelect("desktop");
  };

  popup.querySelector(".mobile").onclick = () => {
    document.body.removeChild(overlay);
    onSelect("mobile");
  };
}

// ==================== EMAIL BUTTON HANDLER ====================

function handleQuotationEmail() {
  if (isMobileDevice()) {
    showEmailLayoutPopup(function (layoutChoice) {
      // layoutChoice will be "desktop" or "mobile"
      sendQuotationEmail(layoutChoice);
    });
  } else {
    // Desktop users: send email immediately
    sendQuotationEmail("desktop");
  }
}

// ==================== EMAIL SENDING LOGIC ====================

async function actuallySendQuotationEmail(payload) {
    const emailButton = document.querySelector('.cs-calc-email-btn');
    const messageDiv = document.getElementById('email-message');

    // 🔹 SHOW LOADING STATE ONLY WHEN EMAIL IS ACTUALLY SENDING
    emailButton.innerHTML = '<div class="cs-calc-button-loading">Sending...</div>';
    emailButton.disabled = true;
    messageDiv.style.display = 'none';

    try {
        const response = await sendJsonpRequest(payload);

        if (response && response.success) {
            showEmailMessage(
                'Quotation sent successfully! Please check your email.',
                'success'
            );

            // Clear form inputs after success
            document.getElementById('customer-name').value = '';
            document.getElementById('customer-email').value = '';
        } else {
            showEmailMessage(
                'Failed to send email: ' + (response?.message || 'Unknown error'),
                'error'
            );
        }

    } catch (error) {
        console.error('Email sending error:', error);

        showEmailMessage(
            'Failed to send email. Please try again.',
            'error'
        );

    } finally {
        // 🔹 ALWAYS RESET BUTTON STATE
        emailButton.innerHTML = 'Send Quotation via Email';
        emailButton.disabled = false;
    }
}

/* =========================================================
   MOBILE FIX: Move component name between icons & image
   ========================================================= */

(function forceVisualizerNamePosition() {

    function repositionName() {
        const nameEl = document.getElementById('component-name-display');
        const visualContainer = document.querySelector('.cs-calc-visual-container');
        const icons = document.querySelector('.cs-calc-visual-icons');

        if (!nameEl || !visualContainer || !icons) return;

        if (window.innerWidth <= 880) {
            // Move name BELOW icons
            if (nameEl.parentNode !== visualContainer) {
                visualContainer.insertBefore(nameEl, icons.nextSibling);
            }
        } else {
            // Move name back ABOVE visual container (desktop)
            const panel = document.querySelector('.cs-calc-visual-panel');
            if (panel && panel.contains(nameEl)) {
                const heading = panel.querySelector('.cs-calc-heading');
                if (heading && heading.nextSibling !== nameEl) {
                    panel.insertBefore(nameEl, heading.nextSibling);
                }
            }
        }
    }

    // Run on load
    document.addEventListener('DOMContentLoaded', repositionName);

    // Run on resize
    window.addEventListener('resize', repositionName);

})();
